<template>
  <div class="animated fadeI">
    <el-form
      :model="mData.dataForm"
      :rules="mData.validForm"
      ref="myProfileForm"
      label-position="left"
      @submit.native.prevent
      label-width="180px"
      :class="mData.viewMode == 'create' ? 'create' : mData.viewMode == 'update' ? 'update' : viewType == 'approveInfomation' ? 'approveInfomation' : ''"
    >
      <!--Thông tin chung-->
      <el-card class="box-card-information-administrative mb-3">
        <div slot="header" class="el-card-header">
          <span class="title-card-header">THÔNG TIN CHUNG</span>
        </div>
        <div class="d-flex w__900">
          <div class="aside__information">
            <div class="div-avatar">
              <div class="fd-r">
                <el-image
                  class="avatar__image"
                  @click="showDetailImage(mData.dataForm.avatarUrl ? mData.dataForm.avatarUrl : 'img/demo.png')"
                  v-if="!loadImage"
                  :src="mData.viewMode == 'create' ? mData.dataForm.avatarUrl ? mData.dataForm.avatarUrl : 'img/demo.png' : mData.dataForm.avatarUrl"
                  fit="cover"
                ></el-image>
              </div>

            </div>
          </div>
          <div class="main__information">
            <b-row>
              <b-col lg="6" md="12">
                <el-form-item label="Mã nhân viên" prop="employee_no">
                  <el-input
                    disabled
                    v-model.trim="mData.dataForm.employee_no"
                    @input="forceUpdateUI"
                    :ref="'employee_no'"
                  ></el-input>
                </el-form-item>
              </b-col>
              
              <b-col lg="6" md="12">
                <el-form-item
                  label="Họ và tên"
                  prop="administrative_info.name.full_name"
                  :class="{
                    'have-change': isFullNameChanged
                  }"
                >
                  <el-input
                    ref="administrative_info.name.full_name"
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation')"
                    v-model="employeeFullNameInput"
                    @change="normalizeEmployeeFullName"
                    @input="handleEmployeeFullNameInput"
                  ></el-input>
                  <p
                    class="text-change mt-2"
                    v-if="isFullNameChanged"
                  >
                    Thông tin cũ: {{oldEmployeeFullName}}
                  </p>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Ngày sinh"
                  prop="administrative_info.birthday"
                  :class="{
                    'have-change': checkConditionChangeData('administrative_info.birthday','date')
                  }"
                >
                  <el-date-picker
                    :ref="'administrative_info.birthday'"
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model="mData.dataForm.administrative_info.birthday"
                    type="date"
                    placeholder=""
                    format="dd/MM/yyyy"
                    @input="forceUpdateUI"
                    :picker-options="pickerBirthdayOptions"
                  >
                  </el-date-picker>
                  <p
                    class="text-change mt-2"
                    v-if="checkConditionChangeData('administrative_info.birthday','date')"
                  >
                    Thông tin cũ: {{formatDate(dataDraff.administrative_info.birthday)}}
                  </p>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Giới tính"
                  prop="administrative_info.gender"
                  :class="{
                    'have-change': checkConditionChangeData('administrative_info.gender')
                  }"
                >
                  <el-select
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model="mData.dataForm.administrative_info.gender"
                    clearable
                    filterable
                    @input="forceUpdateUI"
                    @change="checkStatusVsGender('gender')"
                    ref="administrative_info.gender"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listGioiTinh"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <p
                    class="text-change mt-2"
                    v-if="checkConditionChangeData('administrative_info.gender')"
                  >
                    Thông tin cũ: {{dataDraff.administrative_info.gender == 0 ? 'Nữ' : dataDraff.administrative_info.gender == 1 ? 'Nam' : 'Khác' }}
                  </p>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Địa chỉ"
                  prop="administrative_info.address"
                  :class="{
                    'have-change': checkConditionChangeData('administrative_info.address')
                  }"
                >
                  <el-input
                    ref="administrative_info.address"
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model="mData.dataForm.administrative_info.address"
                    @input="forceUpdateUI"
                  ></el-input>
                  <p
                    class="text-change mt-2"
                    v-if="checkConditionChangeData('administrative_info.address')"
                  >
                    Thông tin cũ: {{dataDraff.administrative_info.address}}
                  </p>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Số điện thoại"
                  prop="administrative_info.phone_number"
                  :class="{
                    'have-change': checkConditionChangeData('administrative_info.phone_number')
                  }"
                >
                  <el-input
                    ref="administrative_info.phone_number"
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model.trim="mData.dataForm.administrative_info.phone_number"
                    @input="forceUpdateUI"
                  ></el-input>
                  <p
                    class="text-change mt-2"
                    v-if="checkConditionChangeData('administrative_info.phone_number')"
                  >
                    Thông tin cũ: {{dataDraff.administrative_info.phone_number}}
                  </p>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Email cá nhân"
                  prop="administrative_info.email"
                  :class="{
                    'have-change': checkConditionChangeData('administrative_info.email')
                  }"
                >
                  <el-input
                    ref="administrative_info.email"
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model.trim="mData.dataForm.administrative_info.email"
                    @change="mData.dataForm.administrative_info.email = mData.dataForm.administrative_info.email.trim()"
                    @input="forceUpdateUI"
                  ></el-input>
                  <p
                    class="text-change mt-2"
                    v-if="checkConditionChangeData('administrative_info.email')"
                  >
                    Thông tin cũ: {{dataDraff.administrative_info.email}}
                  </p>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="CCCD/CMND/Hộ chiếu"
                  prop="administrative_info.identify_card"
                  :class="{
                    'have-change': checkConditionChangeData('administrative_info.identify_card')
                  }"
                >
                  <el-input
                    ref="administrative_info.identify_card"
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model.trim="mData.dataForm.administrative_info.identify_card"
                    @change="mData.dataForm.administrative_info.identify_card = mData.dataForm.administrative_info.identify_card.trim()"
                    @input="forceUpdateUI"
                  ></el-input>
                  <p
                    class="text-change mt-2"
                    v-if="checkConditionChangeData('administrative_info.identify_card')"
                  >
                    Thông tin cũ: {{dataDraff.administrative_info.identify_card}}
                  </p>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item label="Trạng thái" prop="status">
                  <el-select
                    disabled
                    v-model="mData.dataForm.status"
                    filterable
                    @input="forceUpdateUI"
                    ref="status"
                    @change="checkStatusVsGender('status')"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listTrangThai"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <!-- <b-col lg="6" md="12">
                <el-form-item
                  label="Email công ty"
                  prop="administrative_info.company_email"
                >
                  <el-input
                    ref="administrative_info.company_email"
                    disabled
                    v-model.trim="mData.dataForm.administrative_info.company_email"
                    @input="forceUpdateUI"
                  ></el-input>
                </el-form-item>
              </b-col> -->
              
              <b-col lg="6" md="12">
                <el-form-item
                  label="Số năm thâm niên"
                  prop="seniority"
                >
                  <el-input
                    v-if="showSeniority"
                    disabled
                    v-model.trim="mData.dataForm.seniority"
                  ></el-input>
                </el-form-item>
              </b-col>

              

              <b-col lg="6" md="12" v-if="mData.viewMode == 'create'">
                <el-form-item class="account" label="Tài khoản" prop="account">
                  <div class="d-flex" v-if="mData.viewMode == 'create'">
                    <p style="text-transform: lowercase; font-weight: bold; margin-top: 10px;">
                      {{ companyInfo.name.abbreviation_name }}_
                    </p>
                    <el-input
                      :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                      v-model.trim="mData.dataForm.account"
                      @input="forceUpdateUI"
                    ></el-input>
                  </div>
                  <div v-if="mData.viewMode != 'create'">
                    <p class="mt-1" style="text-transform: lowercase">
                      {{ mData.dataForm.account }}
                    </p>
                  </div>
                </el-form-item>
              </b-col>
              
            </b-row>
          </div>
        </div>
        <div v-if="viewType == 'create'" class="d-flex w__900 mt-1">
          <div class="aside__information aside__information--spacer"></div>
          <div class="main__information">
            <b-row>
              <b-col
                xl="12" md="12"
                class="job-info-item"
                v-for="(item, index) in mData.dataForm.job_info"
                :key="`job-info-${index}`"
              >
                <div class="job-info-group mb-1">
                  <b-row>
                    <b-col lg="6" md="12">
                      <el-form-item label="Công ty">
                        <el-input
                          disabled
                          :value="fn_openCompanyName()"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <el-form-item
                        label="Chi nhánh"
                        :prop="'job_info[' + index + '].branch_id'"
                      >
                        <el-select
                          :disabled="!mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104') || (haveDraff && (viewType == 'create' || viewType == 'approveInfomation'))"
                          v-model="item.branch_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listChiNhanh"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <el-form-item
                        label="Phòng ban"
                        :prop="'job_info[' + index + '].department_id'"
                      >
                        <el-select
                          :disabled="!mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104') || (haveDraff && (viewType == 'create' || viewType == 'approveInfomation'))"
                          v-model="item.department_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listPhongBan"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>

                    <b-col xl="6" sm="12">
                      <el-form-item
                        label="Quản lý trực tiếp"
                        :prop="'job_info[' + index + '].direct_manager_id'"
                      >
                        <el-select
                          disabled
                          :value="item.direct_manager_id"
                        >
                          <el-option
                            v-if="item.direct_manager_id"
                            :label="fn_directManagerName(item.direct_manager_id)"
                            :value="item.direct_manager_id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <el-form-item
                        label="Chức vụ"
                        :prop="'job_info[' + index + '].position_id'"
                      >
                        <el-select
                          :disabled="!mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104') || (haveDraff && (viewType == 'create' || viewType == 'approveInfomation'))"
                          v-model="item.position_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listChucVu"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <el-form-item label="Ca làm">
                        <el-select
                          v-if="mData.dataForm.shift.some(s => !s.expiredShift)"
                          :disabled="!mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104') || (haveDraff && (viewType == 'create' || viewType == 'approveInfomation'))"
                          v-model="mData.dataForm.shift[mData.dataForm.shift.findIndex(s => !s.expiredShift)].shift_id"
                          clearable
                          filterable
                          @change="forceUpdateUI"
                        >
                          <el-option
                            v-for="shift in mData.dataDefault.listCaLamViec"
                            :key="shift.id"
                            :label="shift.code + ` (${formatDate(shift.applied_start_time)} - ${formatDate(shift.applied_end_time)})`"
                            :value="shift.id"
                          ></el-option>
                        </el-select>
                        <el-select
                          v-else
                          :disabled="!mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104') || (haveDraff && (viewType == 'create' || viewType == 'approveInfomation'))"
                          value=""
                          clearable
                          filterable
                          @change="(val) => { if (val) { mData.dataForm.shift.push({ shift_id: val, is_need_checkin: true }); forceUpdateUI(); } }"
                        >
                          <el-option
                            v-for="shift in mData.dataDefault.listCaLamViec"
                            :key="shift.id"
                            :label="shift.code + ` (${formatDate(shift.applied_start_time)} - ${formatDate(shift.applied_end_time)})`"
                            :value="shift.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <el-form-item
                        label="Loại hợp đồng"
                        :prop="'job_info[' + index + '].contract_type_id'"
                        v-if="loadContracType"
                      >
                        <el-select
                          :disabled="!mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104') || (haveDraff && (viewType == 'create' || viewType == 'approveInfomation'))"
                          v-model="item.contract_type_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listLoaiHopDong"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <el-form-item
                        label="Ngày bắt đầu"
                        :prop="'job_info[' + index + '].start_date'"
                        v-if="loadTimeStartCT"
                      >
                        <el-date-picker
                          :disabled="!mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104') || (haveDraff && (viewType == 'create' || viewType == 'approveInfomation'))"
                          v-model="item.start_date"
                          type="date"
                          format="dd/MM/yyyy"
                          @change="changeTimeStartInfomationJod(index)"
                          @input="forceUpdateUI"
                          ref="timeStartInfomationJod"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <el-form-item
                        label="Kiểu hợp đồng"
                        :prop="'job_info[' + index + '].kind_of_contract'"
                      >
                        <el-select
                          disabled
                          v-model="item.kind_of_contract"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                        >
                          <el-option
                            v-for="item in DataService.listKindOfContract"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <el-form-item
                        label="Ngày kết thúc"
                        :prop="'job_info[' + index + '].end_date'"
                      >
                        <el-date-picker
                          :disabled="!mData.dataDefault.listFeature.includes('FT103') || !mData.dataDefault.listFeature.includes('FT104') || (haveDraff && (viewType == 'create' || viewType == 'approveInfomation'))"
                          v-model="item.end_date"
                          type="date"
                          format="dd/MM/yyyy"
                          @change="changeTimeEndInfomationJod(index)"
                          @input="forceUpdateUI"
                          ref="timeEndInfomationJod"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <el-form-item
                        label="Ngày bắt đầu làm việc chính thức"
                        :prop="'job_info[' + index + '].official_labor_contract_signed_date'"
                      >
                        <el-date-picker
                          disabled
                          v-model="item.official_labor_contract_signed_date"
                          type="date"
                          placeholder="dd/mm/yyyy"
                          format="dd/MM/yyyy"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col cols="12">
                      <el-form-item
                        label="Không chấm công"
                        :prop="
                          mData.dataForm.shift.some(s => !s.expiredShift)
                            ? 'shift[' + mData.dataForm.shift.findIndex(s => !s.expiredShift) + '].is_need_checkin'
                            : ''
                        "
                      >
                        <el-switch
                          v-if="mData.dataForm.shift.some(s => !s.expiredShift)"
                          :disabled="
                            mData.viewMode != 'detail'
                          "
                          v-model="mData.dataForm.shift[mData.dataForm.shift.findIndex(s => !s.expiredShift)].is_need_checkin"
                          inactive-color="var(--orange)"
                          active-color="#DCDFE6"
                          @input="forceUpdateUI"
                        >
                        </el-switch>
                        <el-switch
                          v-else
                          disabled
                          inactive-color="var(--orange)"
                          active-color="#DCDFE6"
                        >
                        </el-switch>
                      </el-form-item>
                    </b-col>
                    <b-col md="6" class="mt-1">
                      <el-form-item
                        label="Upload hồ sơ"
                        prop="administrative_info.facebook"
                      >
                        <el-upload
                          class="employee-file"
                          :auto-upload="false"
                          list-type="text"
                          drag
                          action
                          :limit="mData.fileUploadOption.FileHoSo.limit"
                          :accept="mData.fileUploadOption.FileHoSo.accept"
                          :on-change="fn_uploadFile"
                          :on-preview="fn_downloadFile"
                          :on-remove="fn_removeFile"
                          :file-list="mData.fileUploadOption.FileHoSo.fileList"
                          multiple
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                        >
                          <div class="el-upload__text">
                            Thả file vào đây hoặc <em>click để upload</em>
                          </div>
                        </el-upload>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-col md="12" class="social-div">
          <div
            class="add-new-social__network"
          >
            <p
              v-if="!checkEnoughSocialNetwork"
              @click="addNewSocialNetwork"
              class="add-new-social__network-text"
            >
              <span class="plus">+ </span>
              <span class="underline">Liên kết xã hội</span>
            </p>
            <p
              v-if="checkEnoughSocialNetwork"
              class="mr-4"
            >
              Liên kết xã hội
            </p>
          </div>

          <div
            class="social-media"
          >
            <div>
              <div
                v-for="(e,i) in mData.dataForm.social_networks"
                :key="i"
                class="social-media__box"
              >
                <img :src="`img/${e.type}.png`" alt="" class="social__media-icon">
                <p
                  @click="goToLinkUrl(e.url)"
                  class="social-network__url"
                  :title="e.url"
                >
                  {{e.url}}
                </p>
                <i class="isax-save-remove" title="Xóa" @click="removeSocialNetwork(i)"></i>
                <i class="isax-edit" title="Cập nhật" @click="updateSocialNetwork(e)"></i>
              </div>
            </div>
          </div>
        </b-col>
      </el-card>
      <!-- Tiền lương trợ cấp-->
      <el-collapse v-if="viewType == 'create'" class="box-card-salary mb-3" v-model="activeName5" accordion>
        <el-collapse-item name="box-card-salary">
          <template slot="title">
            <span class="title-card-header">Tiền lương/Trợ cấp</span>
          </template>
          <div>
            <b-row style="position: relative">
              <b-col md="6">
                <el-form-item
                  label="Hình thức chi trả"
                  prop="salary.payment_method"
                >
                  <el-input
                  :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model="mData.dataForm.salary.payment_method"
                    clearable
                    @input="forceUpdateUI"
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Bậc lương" prop="salary.rank_salary_id">
                  <el-select
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model="mData.dataForm.salary.rank_salary_id"
                    clearable
                    filterable
                    @input="forceUpdateUI"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listBacLuong"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Ngân hàng" prop="salary.bank_name">
                  <el-input
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model="mData.dataForm.salary.bank_name"
                    clearable
                    @input="forceUpdateUI"
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item
                  label="Lương Gross"
                  prop="salary.gross_salary"
                >
                  <ElementUIMoney
                    v-model="mData.dataForm.salary.gross_salary"
                    label=""
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    :outlined="true"
                    :clearable="true"
                    :options="options"
                  />
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Số tài khoản" prop="salary.bank_account">
                  <el-input
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model="mData.dataForm.salary.bank_account"
                    clearable
                    @input="forceUpdateUI"
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item
                  label="Lương đóng bảo hiểm"
                  prop="salary.insurance_salary"
                >
                  <ElementUIMoney
                    v-model="mData.dataForm.salary.insurance_salary"
                    label=""
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    :outlined="true"
                    :clearable="true"
                    :options="options"
                  />
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Chi nhánh" prop="salary.bank_branch">
                  <el-input
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model="mData.dataForm.salary.bank_branch"
                    clearable
                    @input="forceUpdateUI"
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item
                  label="Hệ số lương"
                  prop="salary.coefficient_salary_id"
                >
                  <el-select
                    :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                    v-model="mData.dataForm.salary.coefficient_salary_id"
                    clearable
                    filterable
                    @input="forceUpdateUI"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listHeSoLuong"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col lg="6" md="12">
                <el-form-item
                  label="Số sổ bảo hiểm"
                  prop="insurance_book_number"
                >
                  <el-input
                    disabled
                    v-model.trim="mData.dataForm.insurance_book_number"
                    @change="mData.dataForm.insurance_book_number = mData.dataForm.insurance_book_number.trim()"
                    @input="forceUpdateUI"
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col xl="12" class="subsidize">
                <el-form-item label="Trợ cấp" :rules="ValidService.requied">
                  <b-row
                    v-for="(item, index) in mData.dataForm.salary.subsidies_salary"
                    :key="index"
                    style="margin-bottom: 13px; margin-left: -3px"
                  >
                    <b-col xl="4" sm="3" class="pl-1">
                      <el-form-item
                        :prop="
                          'salary.subsidies_salary[' +
                          index +
                          '].subsidies_salary_type_id'
                        "
                      >
                        <el-select
                          class="mb-1"
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.subsidies_salary_type_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTroCap"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xl="4" sm="3">
                      <el-form-item
                        :prop="'salary.subsidies_salary[' + index + '].value'"
                      >
                        <ElementUIMoney
                          v-model="item.value"
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          label=""
                          :outlined="true"
                          placeholder="Giá trị trợ cấp"
                          :clearable="true"
                          :options="options"
                        />
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-form-item>
              </b-col>
            </b-row>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!--Trình độ chuyên môn-->
      <el-collapse class="box-card mb-3" v-model="activeName2" accordion>
        <el-collapse-item name="box-card-qualification">
          <template slot="title">
            <span class="title-card-header">Trình độ chuyên môn</span>
          </template>
          <div>
            <b-row>
              <b-col
                xl="6"
                v-for="(item, index) in mData.dataForm.qualification"
                :key="index"
              >
                <div v-if="item.type == 'add'" class="p-relative">
                  <div
                    title="Xóa"
                    class="remove-icon c-ponit"
                    @click="removeQualification(item.key)"
                  >
                    <el-image
                      style="width: 100%"
                      src="img/remove_icon.png"
                      fit="cover"
                    >
                    </el-image>
                  </div>
                </div>
                <el-card
                  :class="{
                    'box-card-qualification mb-3': true,
                    'object-have-change': checkConditionChangeDataObject(index, 'qualification'),
                  }"
                >
                  <b-row>
                    <b-col sm="12">
                      <el-form-item
                        label="Trình độ"
                        :prop="'qualification[' + index + '].qualification_id'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'qualification', 'qualification_id'),
                        }"
                      >
                        <el-select
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.qualification_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          :ref="`qualification[${index}].qualification_id`"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTrinhDo"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'qualification', 'qualification_id')"
                        >
                          Thông tin cũ: {{getNameById(dataDraff.qualification[index] && dataDraff.qualification[index].qualification_id ? dataDraff.qualification[index].qualification_id : '', 'listTrinhDo')}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Chuyên ngành"
                        :prop="'qualification[' + index + '].major_id'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'qualification', 'major_id'),
                        }"
                      >
                        <el-select
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.major_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          :ref="`qualification[${index}].major_id`"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listChuyenNganh"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'qualification', 'major_id')"
                        >
                          Thông tin cũ: {{getNameById(dataDraff.qualification[index] && dataDraff.qualification[index].major_id ? dataDraff.qualification[index].major_id : '', 'listChuyenNganh')}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Ngày cấp"
                        :prop="'qualification[' + index + '].issued_date'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'qualification', 'issued_date', 'date'),
                        }"
                      >
                        <el-date-picker
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.issued_date"
                          type="date"
                          format="dd/MM/yyyy"
                          @input="forceUpdateUI"
                          :ref="`qualification[${index}].issued_date`"
                        >
                        </el-date-picker>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'qualification', 'issued_date', 'date')"
                        >
                          Thông tin cũ: {{formatDate(dataDraff.qualification[index] && dataDraff.qualification[index].issued_date ? dataDraff.qualification[index].issued_date : '')}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Nơi cấp"
                        :prop="'qualification[' + index + '].issued_by'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'qualification', 'issued_by'),
                        }"
                      >
                        <el-input
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.issued_by"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          :ref="`qualification[${index}].issued_by`"
                        >
                        </el-input>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'qualification', 'issued_by')"
                        >
                          Thông tin cũ: {{dataDraff.qualification[index] && dataDraff.qualification[index].issued_by ? dataDraff.qualification[index].issued_by : ''}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col xl="12">
                      <el-form-item
                        label="Ghi chú"
                        :prop="'qualification[' + index + '].note'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'qualification', 'note'),
                        }"
                      >
                        <el-input
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.note"
                          type="textarea"
                          :rows="2"
                          @input="forceUpdateUI"
                          :ref="`qualification[${index}].note`"
                        >
                        </el-input>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'qualification', 'note')"
                        >
                          Thông tin cũ: {{dataDraff.qualification[index] && dataDraff.qualification[index].note ? dataDraff.qualification[index].note : ''}}
                        </p>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-card>
              </b-col>
            </b-row>
            <div
              v-if="!haveDraff || viewType == 'showDataApprove'"
              class="d-flex jc-end"
            >
              <div
                class="img__icon-plus mouse__hover ml-2"
                @click="newQualification"
              >
                <el-image
                  src="img/plus.png"
                  fit="cover"
                ></el-image>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!--Chững chỉ-->
      <el-collapse class="box-card mb-3" v-model="activeName3" accordion>
        <el-collapse-item name="box-card-certificate">
          <template slot="title">
            <span class="title-card-header">Chứng chỉ</span>
          </template>
          <div>
            <b-row>
              <b-col
                xl="6"
                v-for="(item, index) in mData.dataForm.certificate"
                :key="index"
              >
                <div v-if="item.type == 'add'" class="p-relative">
                  <div
                    title="Xóa"
                    class="remove-icon c-ponit"
                    @click="removeCertificate(item.key)"
                  >
                    <el-image
                      style="width: 100%"
                      src="img/remove_icon.png"
                      fit="cover"
                    >
                    </el-image>
                  </div>
                </div>
                <el-card
                  :class="{
                    'box-card-certificate mb-3': true,
                    'object-have-change': checkConditionChangeDataObject(index, 'certificate'),
                  }"
                >
                  <b-row>
                    <b-col xl="12">
                      <el-form-item
                        label="Tên chứng chỉ"
                        :prop="'certificate[' + index + '].name'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'certificate', 'name'),
                        }"
                      >
                        <el-input
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.name"
                          clearable
                          @input="forceUpdateUI"
                          :ref="`certificate[${index}].name`"
                        >
                        </el-input>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'certificate', 'name')"
                        >
                          Thông tin cũ: {{dataDraff.certificate[index] && dataDraff.certificate[index].name ? dataDraff.certificate[index].name : ''}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Ngày cấp"
                        :prop="'certificate[' + index + '].issued_date'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'certificate', 'issued_date', 'date'),
                        }"
                      >
                        <el-date-picker
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.issued_date"
                          type="date"
                          format="dd/MM/yyyy"
                          @input="forceUpdateUI"
                          :ref="`certificate[${index}].issued_date`"
                        >
                        </el-date-picker>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'certificate', 'issued_date', 'date')"
                        >
                          Thông tin cũ: {{formatDate(dataDraff.certificate[index] && dataDraff.certificate[index].issued_date ? dataDraff.certificate[index].issued_date : '')}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Nơi cấp"
                        :prop="'certificate[' + index + '].issued_by'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'certificate', 'issued_by'),
                        }"
                      >
                        <el-input
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.issued_by"
                          clearable
                          @input="forceUpdateUI"
                          :ref="`certificate[${index}].issued_by`"
                        >
                        </el-input>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'certificate', 'issued_by')"
                        >
                          Thông tin cũ: {{dataDraff.certificate[index] && dataDraff.certificate[index].issued_by ? dataDraff.certificate[index].issued_by : ''}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col xl="12">
                      <el-form-item
                        label="Ghi chú"
                        :prop="'certificate[' + index + '].note'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'certificate', 'note'),
                        }"
                      >
                        <el-input
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.note"
                          type="textarea"
                          :rows="2"
                          @input="forceUpdateUI"
                          :ref="`certificate[${index}].note`"
                        >
                        </el-input>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'certificate', 'note')"
                        >
                          Thông tin cũ: {{dataDraff.certificate[index] && dataDraff.certificate[index].note ? dataDraff.certificate[index].note : ''}}
                        </p>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-card>
              </b-col>
            </b-row>
            <div
              v-if="!haveDraff || viewType == 'showDataApprove'"
              class="d-flex jc-end"
            >
              <div
                class="img__icon-plus mouse__hover ml-2"
                @click="newCertificate"
              >
                <el-image
                  src="img/plus.png"
                  fit="cover"
                ></el-image>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!-- Thông tin liên hệ khác-->
      <el-collapse class="box-card-other mb-3" v-model="activeName4" accordion>
        <el-collapse-item name="box-card-other-contact-information">
          <template slot="title">
            <span class="title-card-header">Thông tin liên hệ khác</span>
          </template>
          <div>
            <b-row>
              <b-col
                xl="6"
                v-for="(item, index) in mData.dataForm.other_contact_info"
                :key="index"
              >
                <div v-if="item.type == 'add'" class="p-relative">
                  <div
                    title="Xóa"
                    class="remove-icon c-ponit"
                    @click="removeOtherContactInformation(item.key)"
                  >
                    <el-image
                      style="width: 100%"
                      src="img/remove_icon.png"
                      fit="cover"
                    >
                    </el-image>
                  </div>
                </div>
                <el-card
                  :class="{
                    'box-card-other-contact-info mb-3': true,
                    'object-have-change': checkConditionChangeDataObject(index, 'other_contact_info'),
                  }"
                >
                  <b-row>
                    <b-col sm="12">
                      <el-form-item
                        label="Họ và tên"
                        :prop="'other_contact_info[' + index + '].full_name'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'other_contact_info', 'full_name'),
                        }"
                      >
                        <el-input
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.full_name"
                          clearable
                          @input="forceUpdateUI"
                          :ref="`other_contact_info[${index}].full_name`"
                        >
                        </el-input>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'other_contact_info', 'full_name')"
                        >
                          Thông tin cũ: {{dataDraff.other_contact_info[index] && dataDraff.other_contact_info[index].full_name ? dataDraff.other_contact_info[index].full_name : ''}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Quan hệ"
                        :prop="'other_contact_info[' + index + '].relationship_id'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'other_contact_info', 'relationship_id'),
                        }"
                      >
                        <el-select
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.relationship_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          :ref="`other_contact_info[${index}].relationship_id`"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listMoiQuanHe"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'other_contact_info', 'relationship_id')"
                        >
                          Thông tin cũ: {{getNameById(dataDraff.other_contact_info[index] && dataDraff.other_contact_info[index].relationship_id ? dataDraff.other_contact_info[index].relationship_id : '', 'listMoiQuanHe')}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col sm="12">
                      <el-form-item
                        label="Điện thoại"
                        :prop="'other_contact_info[' + index + '].phone_number'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'other_contact_info', 'phone_number'),
                        }"
                      >
                        <el-input
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.phone_number"
                          clearable
                          @input="forceUpdateUI"
                          :ref="`other_contact_info[${index}].phone_number`"
                        >
                        </el-input>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'other_contact_info', 'phone_number')"
                        >
                          Thông tin cũ: {{dataDraff.other_contact_info[index] && dataDraff.other_contact_info[index].phone_number ? dataDraff.other_contact_info[index].phone_number : ''}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col xl="12">
                      <el-form-item
                        label="Địa chỉ"
                        :prop="'other_contact_info[' + index + '].address'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'other_contact_info', 'address'),
                        }"
                      >
                        <el-input
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.address"
                          clearable
                          @input="forceUpdateUI"
                          :ref="`other_contact_info[${index}].address`"
                        >
                        </el-input>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'other_contact_info', 'address')"
                        >
                          Thông tin cũ: {{dataDraff.other_contact_info[index] && dataDraff.other_contact_info[index].address ? dataDraff.other_contact_info[index].address : ''}}
                        </p>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-card>
              </b-col>
            </b-row>
            <div
              v-if="!haveDraff || viewType == 'showDataApprove'"
              class="d-flex jc-end"
            >
              <div
                class="img__icon-plus mouse__hover ml-2"
                @click="newOtherContactInformation"
              >
                <el-image
                  src="img/plus.png"
                  fit="cover"
                ></el-image>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!-- Thông tin người phụ thuộc -->
      <el-collapse class="box-card mb-3" v-model="activeName6" accordion>
        <el-collapse-item name="box-card-dependent-person">
          <template slot="title">
            <span class="title-card-header">Thông tin người phụ thuộc</span>
          </template>
          <div>
            <b-row>
              <b-col
                xl="6"
                v-for="(item, index) in mData.dataForm.dependent_person_info"
                :key="index"
              >
                <div v-if="item.type == 'add'" class="p-relative">
                  <div
                    title="Xóa"
                    class="remove-icon c-ponit"
                    @click="removeDependentPerson(item.key)"
                  >
                    <el-image
                      style="width: 100%"
                      src="img/remove_icon.png"
                      fit="cover"
                    >
                    </el-image>
                  </div>
                </div>
                <el-card
                  :class="{
                    'box-card-dependent-person-info mb-3': true,
                    'object-have-change': checkConditionChangeDataObject(index, 'dependent_person_info'),
                  }"
                >
                  <b-row>
                    <b-col xl="12">
                      <el-form-item
                        label="Họ và tên"
                        :prop="'dependent_person_info[' + index + '].full_name'"
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'dependent_person_info', 'full_name'),
                        }"
                      >
                        <el-input
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.full_name"
                          clearable
                          @input="forceUpdateUI"
                          :ref="`dependent_person_info[${index}].full_name`"
                        >
                        </el-input>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'dependent_person_info', 'full_name')"
                        >
                          Thông tin cũ: {{dataDraff.dependent_person_info[index] && dataDraff.dependent_person_info[index].full_name ? dataDraff.dependent_person_info[index].full_name : ''}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col xl="12">
                      <el-form-item
                        label="Mối quan hệ"
                        :prop="
                          'dependent_person_info[' + index + '].relationship_id'
                        "
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'dependent_person_info', 'relationship_id'),
                        }"
                      >
                        <el-select
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.relationship_id"
                          clearable
                          filterable
                          @input="forceUpdateUI"
                          :ref="`dependent_person_info[${index}].relationship_id`"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listMoiQuanHe"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'dependent_person_info', 'relationship_id')"
                        >
                          Thông tin cũ: {{getNameById(dataDraff.dependent_person_info[index] && dataDraff.dependent_person_info[index].relationship_id ? dataDraff.dependent_person_info[index].relationship_id : '', 'listMoiQuanHe')}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item
                        label="Ngày đăng ký"
                        :prop="
                          'dependent_person_info[' + index + '].registered_date'
                        "
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'dependent_person_info', 'registered_date', 'date'),
                        }"
                      >
                        <el-date-picker
                          :disabled="haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )"
                          v-model="item.registered_date"
                          type="date"
                          format="dd/MM/yyyy"
                          @input="forceUpdateUI"
                          @change="changeTimeStartDependentPerson(index)"
                          :ref="`dependent_person_info[${index}].registered_date`"
                        >
                        </el-date-picker>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'dependent_person_info', 'registered_date', 'date')"
                        >
                          Thông tin cũ: {{formatDate(dataDraff.dependent_person_info[index] && dataDraff.dependent_person_info[index].registered_date ? dataDraff.dependent_person_info[index].registered_date : '')}}
                        </p>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item
                        label="Ngày hết hạn"
                        :prop="
                          'dependent_person_info[' + index + '].expired_date'
                        "
                        :class="{
                          'have-change': checkConditionChangeDataObjectField(index, 'dependent_person_info', 'expired_date', 'date'),
                        }"
                      >
                        <el-date-picker
                          :disabled="(haveDraff && (viewType == 'create' || viewType == 'approveInfomation' )) || mData.viewMode == 'detail' || !item.registered_date"
                          v-model="item.expired_date"
                          type="date"
                          placeholder=""
                          format="dd/MM/yyyy"
                          @input="forceUpdateUI"
                          @change="changeTimeEndDependentPerson(index)"
                          :ref="`dependent_person_info[${index}].expired_date`"
                        >
                        </el-date-picker>
                        <p
                          class="text-change mt-2"
                          v-if="checkConditionChangeDataObjectField(index, 'dependent_person_info', 'expired_date', 'date')"
                        >
                          Thông tin cũ: {{formatDate(dataDraff.dependent_person_info[index] && dataDraff.dependent_person_info[index].expired_date ? dataDraff.dependent_person_info[index].expired_date : '')}}
                        </p>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </el-card>
              </b-col>
            </b-row>
            <div
              v-if="!haveDraff || viewType == 'showDataApprove'"
              class="d-flex jc-end"
            >
              <div
                class="img__icon-plus mouse__hover ml-2"
                @click="newDependentPerson"
              >
                <el-image
                  src="img/plus.png"
                  fit="cover"
                ></el-image>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!-- Thông tin chữ ký nhân viên -->
      <el-collapse class="box-card mb-2" v-model="activeName7" accordion="">
        <el-collapse-item name="box-card-sign">
          <template slot="title">
            <span class="title-card-header">THÔNG TIN CHỮ KÝ NHÂN VIÊN</span>
          </template>
          <div class="signature-section" :class="{ 'signature-section--empty': !fn_getFirstSignImage() }">
            <b-row class="signature-section__row">
              <b-col
                :lg="fn_getFirstSignImage() ? 6 : 12"
                md="12"
                class="signature-section__upload-col"
                :class="{ 'signature-section__upload-col--full': !fn_getFirstSignImage() }"
              >
                <div class="signature-section__label">ẢNH CHỮ KÝ</div>
                <el-upload
                  class="signature-upload"
                  :auto-upload="false"
                  drag
                  action
                  :show-file-list="false"
                  :accept="mData.fileUploadOption.FileChuKy.accept"
                  :on-change="fn_uploadSign"
                  :disabled="!fn_canEditSignature()"
                >
                  <i class="el-icon-upload signature-upload-icon"></i>
                  <div class="el-upload__text signature-upload-text">
                    Kéo thả ảnh vào đây hoặc <em>click để upload</em>
                  </div>
                </el-upload>
                <p class="signature-section__hint">
                  <i>Chỉ hỗ trợ file định dạng PNG, có kích thước không quá 220 x 220px.</i>
                </p>
              </b-col>
              <b-col
                v-if="fn_getFirstSignImage()"
                lg="6"
                md="12"
                class="signature-section__right-col"
              >
                <b-row class="signature-section__right-row">
                  <b-col sm="6" cols="12" class="signature-section__preview-col">
                    <div class="signature-section__label">XEM TRƯỚC</div>
                    <div class="signature-preview-box">
                      <el-image
                        class="signature-preview-image"
                        :src="fn_getFirstSignImage().url"
                        fit="contain"
                      ></el-image>
                      <el-button
                        class="btn-back signature-preview-delete"
                        v-if="fn_canEditSignature()"
                        @click="fn_removeSignImage(fn_getFirstSignImage().id)"
                        title="Xóa"
                      >
                        <i class="el-icon-delete"></i>
                      </el-button>
                    </div>
                    <el-button
                      class="signature-view-btn"
                      @click="showDetailImage(fn_getFirstSignImage().url)"
                    >
                      <i class="el-icon-view"></i>
                      Xem kích thước thật
                    </el-button>
                  </b-col>
                  <b-col sm="6" cols="12" class="signature-section__notes-col">
                    <div class="signature-notes-card">
                      <div class="signature-notes-card__header">
                        <i class="el-icon-warning-outline"></i>
                        <span>Lưu ý</span>
                      </div>
                      <ul class="signature-notes-card__list">
                        <li>Nền chữ ký nên là màu trắng hoặc trong suốt.</li>
                        <li>Chữ ký rõ nét, không bị mờ hoặc nhòe.</li>
                        <li>Kích thước tối đa: 220 x 220px.</li>
                        <li>Định dạng: PNG.</li>
                      </ul>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!-- dialog show lịch sử ca làm việc -->
      <el-dialog
        :visible.sync="mData.showHistoryShift"
        :close-on-click-modal="true"
        width="60%"
        top="35px"
        title="Lịch sử ca làm việc"
        class="dialog-history"
      >
        <b-row>
          <b-col
            md="6"
            v-for="(item, index) in mData.dataForm.shift"
            :key="index"
            :class="{ hide_div: !item.expiredShift }"
          >
            <el-card class="box-card-information-timekeeping mb-3">
              <b-row>
                <b-col md="12">
                  <el-form-item
                    label="Ca làm"
                    :prop="'shift[' + index + '].shift_id'"
                  >
                    <el-select
                      disabled
                      v-model="item.shift_id"
                      clearable
                      filterable
                      @input="forceUpdateUI"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listCaLamViec"
                        :key="item.id"
                        :label="
                          item.code +
                          ` (${formatDate(
                            item.applied_start_time
                          )} - ${formatDate(item.applied_end_time)})`
                        "
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item
                    label="Ngày bắt đầu"
                    :prop="'shift[' + index + '].start_time'"
                  >
                    <el-date-picker
                      disabled
                      v-model="item.start_time"
                      clearable
                      type="date"
                      placeholder=""
                      format="dd/MM/yyyy"
                      @input="forceUpdateUI"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item
                    label="Ngày kết thúc"
                    :prop="'shift[' + index + '].end_time'"
                  >
                    <el-date-picker
                      disabled
                      v-model="item.end_time"
                      clearable
                      type="date"
                      format="dd/MM/yyyy"
                      @input="forceUpdateUI"
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item
                    label="Không chấm công"
                    :prop="'shift[' + index + '].is_need_checkin'"
                  >
                    <el-switch
                      disabled
                      v-model="item.is_need_checkin"
                      inactive-color="#1597E5"
                      active-color="#DCDFE6"
                      @input="forceUpdateUI"
                    >
                    </el-switch>
                  </el-form-item>
                </b-col>
              </b-row>
            </el-card>
          </b-col>
        </b-row>
      </el-dialog>
    </el-form>
    <!--Disalog show anh CMND -->
    <el-dialog
      :visible.sync="mData.fileUploadOption.dialogVisible"
      :close-on-click-modal="true"
      width="40%"
      top="40px"
      title="Chi tiết"
    >
      <img
        class="dialog-image"
        width="100%"
        :src="mData.fileUploadOption.dialogImageUrl"
        alt=""
      />
    </el-dialog>
    <!-- Dialog thêm mới Social Media Network -->
    <el-dialog
      class="dialog__social-netwotk"
      :title="(typeChangeSocialNetwork == 'create' ? 'Thêm mới' : 'Cập nhật') + ' liên kết xã hội'"
      :visible.sync="visibleDialogSocialNetwork"
      width="500px"
      :before-close="beforeCloseDialogSocialNetwork"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          ref="formSocialNetwork"
          :model="mData.dataFormSocialNetWork"
          :rules="mData.validFormSocialNetWork"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="Loại mạng xã hội" prop="type">
                <el-select
                  v-model="mData.dataFormSocialNetWork.type"
                  filterable
                  clearable
                  @input="forceUpdateUI"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listSocialMediaNetwork"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="URL" prop="url">
                <el-input
                  v-model="mData.dataFormSocialNetWork.url"
                  @change="() => {mData.dataFormSocialNetWork.url = mData.dataFormSocialNetWork.url.trim()}"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12" class="text-center">
              <el-button
                v-if="typeChangeSocialNetwork == 'create'"
                type="primary"
                @click="submitFormSocialNetwork('create')"
              >
                Thêm mới
              </el-button>
              <el-button
                v-if="typeChangeSocialNetwork != 'create'"
                type="primary"
                @click="submitFormSocialNetwork('update')"
              >
                Cập nhật
              </el-button>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </el-dialog>
    <!-- Dialog xem chi tiết ảnh -->
    <el-image-viewer
      class="dialog__image-viewer"
      v-if="visibleDialogImage"
      :on-close="closeViewer"
      :url-list="[urlImage]"
    />
    <Loading v-if="loading" />
  </div>
</template>

<script>
import ValidService from "../../service/ValidService";
import DataService from "../../service/DataService";
import MethodService from "../../service/MethodService";
import ExtensionService from "../../service/ExtensionService";
import EmployeeModel from "../../views/admin/Employees/EmployeeModel";
import EventBus from "../../service/EventBus";
import ShiftApi from "../../moduleApi/ShiftApi";
import ContractTypeApi from "../../moduleApi/ContractTypeApi";
import BranchApi from "../../moduleApi/BranchApi";
import DepartmentApi from "../../moduleApi/DepartmentApi";
import PositionApi from "../../moduleApi/PositionApi";
import QualificationApi from "../../moduleApi/QualificationApi";
import MajorApi from "../../moduleApi/MajorApi";
import RelationshipApi from "../../moduleApi/RelationshipApi";
import CoefficientSalaryApi from "../../moduleApi/CoefficientSalaryApi";
import RankSalaryApi from "../../moduleApi/RankSalaryApi";
import SubsidiesSalaryTypeApi from "../../moduleApi/SubsidiesSalaryTypeApi";
import EmployeeDraffApi from "../../moduleApi/EmployeeDraffApi";
import EmployeeApi from "../../moduleApi/EmployeeApi";
import EmployeeShiftApi from "../../moduleApi/EmployeeShiftApi";
import FileApi from "../../moduleApi/FileApi";
import EmployeeSignatureApi from "../../moduleApi/EmployeeSignatureApi";
import EmployeeSignatureDraffApi from "../../moduleApi/EmployeeSignatureDraffApi";
import ElementUIMoney from "../InputComponent/ElementUiMoney";
import * as moment from "moment";
import Loading from "../Loading";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: {
    ElementUIMoney,
    Loading,
    ElImageViewer
  },
  props: {
    dataDraff: {
      type: Object,
      default: undefined
    },
    dataSignatureDraff: {
      type: Object,
      default: undefined
    },
    haveDraff: {
      type: Boolean,
      default: false
    },
    viewType: {
      type: String,
      default: "create"
    },
  },
  data() {
    return {
      DataService,
      MethodService,
      ValidService,
      showButtonDelete: false,
      showSeniority: true,
      loadPersonalImage: false,
      loadImage: false,
      loadShift: true,
      loadTimeStart: true,
      loadTimeStartCT: true,
      loadContracType: true,
      checkEnoughSocialNetwork: false,
      visibleDialogSocialNetwork: false,
      typeChangeSocialNetwork: 'create',
      visibleDialogImage: false,
      urlImage: "",
      employeeFullNameInput: "",
      haveLaborContract: false,
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 100,
        precision: 0,
      },
      pickerBirthdayOptions: {
        disabledDate(time) {
          return time.getTime() >= new Date().getTime()
        },
      },
      pickerOptions: {},
      loading: false,
      type: "",
      imgUrl: ExtensionService.urlImg,
      activeName: "box-card-information-job",
      activeName2: "box-card-qualification1",
      activeName3: "box-card-certificate1",
      activeName4: "box-card-other-contact-information1",
      activeName5: "box-card-salary1",
      activeName6: "box-card-dependent-person1",
      activeName7: "box-card-sign1",
      mData: {
        checkCallaApiEmployee: false,
        haveHistoryShift: false,
        showHistoryShift: false,
        haveDraff: false,
        routerParamId: "",
        moduleName: "EmployeeManager", //requied
        dataForm: MethodService.copyObject(EmployeeModel.dataForm),
        dataFormEmployeeSignature: undefined,
        dataFormSocialNetWork: {
          type: undefined,
          url: undefined
        },
        validFormSocialNetWork: {
          type: [ValidService.requiredChange],
          url: [ValidService.required]
        },
        validForm: EmployeeModel.validForm,
        tableRules: MethodService.copyObject(EmployeeModel.tableRules),
        shiftRemove: [],
        listTypeSocialNetwork: [],
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          anh: "",
          listGioiTinh: DataService.listGioiTinh,
          listCaLamViec: [],
          listLoaiHopDong: [],
          listChiNhanh: [],
          listPhongBan: [],
          listChucVu: [],
          listTrangThai: DataService.listTrangThaiLamViec,
          listTrinhDo: [],
          listChuyenNganh: [],
          listHeSoLuong: [],
          listBacLuong: [],
          listMoiQuanHe: [],
          listTroCap: [],
          listAllShift: [],
          listThoiGian: DataService.listThoiGianDiMuonVeSom,
          listShiftValidTime: [],
          listShiftValidTimeCheckDublicate: [],
          listSocialMediaNetwork: DataService.listSocialMediaNetwork
        },
        fileUploadOption: {
          dialogImageUrl: "",
          dialogVisible: false,
          Anh: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          AnhCaNhan: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          FileHoSo: {
            limit: null,
            accept: ".jpg, .png, .jpeg, .docx, .doc, .xlsx, .xls, .csv, .pdf,",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          MatTruocCMND: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          MatSauCMND: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          FileChuKy: {
            accept: ".png",
            dialogImageUrl: "",
            listImageSign: []
          },
        },
        isHaveTheChamCong: false,
        employeeId: "",
        timeDiMuon: 0,
        timeVeSom: 0,
      },
      haveAvatar: false,
      signaturePreviewImage: null,
      userProfile: {},
      currentUser: {},
      companyInfo: {},
      directManagerNamesById: {},
      arrShiftIds: [],
      arrContractTypeIds: [],
      arrPositionIds: [],
      arrBranchIds: [],
      arrDepartmentIds: [],
      arrCoefficientSalaryIds: [],
      arrRankSalaryIds: [],
      arrSubsidiesSalaryTypeIds: [],
      arrQualificationIds: [],
      arrMajorIds: [],
      arrRelationshipIds: []
    };
  },
  computed: {
    isFullNameChanged() {
      return this.checkConditionChangeData("administrative_info.name.full_name") ||
        this.checkConditionChangeData("administrative_info.name.first_name") ||
        this.checkConditionChangeData("administrative_info.name.last_name");
    },
    oldEmployeeFullName() {
      return [
        _.get(this.dataDraff, "administrative_info.name.last_name"),
        _.get(this.dataDraff, "administrative_info.name.first_name")
      ].filter(value => value).join(" ").trim();
    }
  },
  methods: {
    applyFullNameValidation() {
      this.mData.validForm = MethodService.copyObject(EmployeeModel.validForm);
      this.mData.validForm.administrative_info.name.first_name = [];
      this.mData.validForm.administrative_info.name.last_name = [];
      this.mData.validForm.administrative_info.name.full_name = [
        ValidService.required,
        ValidService.checkSpaceString,
        ValidService.checkVietNameseNoNumber
      ];
    },
    syncEmployeeFullNameInput() {
      this.employeeFullNameInput = [
        _.get(this.mData.dataForm, "administrative_info.name.last_name"),
        _.get(this.mData.dataForm, "administrative_info.name.first_name")
      ].filter(value => value).join(" ").trim();
    },
    setEmployeeNameFields(fullNameValue) {
      const nameParts = fullNameValue ? fullNameValue.split(" ") : [];
      const firstName = nameParts.length ? nameParts.pop() : undefined;
      const lastName = nameParts.length ? nameParts.join(" ") : undefined;

      this.mData.dataForm.administrative_info.name.full_name = fullNameValue || undefined;
      this.mData.dataForm.administrative_info.name.first_name = firstName;
      this.mData.dataForm.administrative_info.name.last_name = lastName;
    },
    handleEmployeeFullNameInput() {
      this.setEmployeeNameFields(this.employeeFullNameInput);
      this.forceUpdateUI();
    },
    normalizeEmployeeFullName() {
      this.employeeFullNameInput = this.employeeFullNameInput
        ? MethodService.trimSpace(this.employeeFullNameInput.trim())
        : "";
      this.setEmployeeNameFields(this.employeeFullNameInput);
    },
    fn_openCompanyName() {
      const companyName = this.companyInfo.name || {};
      return companyName.name_vi ||
        companyName.abbreviation_name ||
        companyName.name_en ||
        this.mData.dataForm.company_id ||
        "";
    },
    fn_directManagerName(managerId) {
      return this.directManagerNamesById[managerId] || managerId || "";
    },
    fn_getDirectManagerLabel(employee) {
      if (!employee) return "";
      const fullName =
        employee.name ||
        employee.full_name ||
        (employee.administrative_info &&
        employee.administrative_info.name &&
        employee.administrative_info.name.full_name
          ? employee.administrative_info.name.full_name
          : "") ||
        "";
      return employee.employee_no ? `${employee.employee_no} - ${fullName}` : fullName;
    },
    async fn_loadDirectManagerNames() {
      const managerIds = [...new Set(
        (this.mData.dataForm.job_info || [])
          .map((job) => job && job.direct_manager_id)
          .filter(Boolean)
      )];

      if (managerIds.length === 0) {
        this.directManagerNamesById = {};
        return;
      }

      const directManagerEntries = await Promise.all(
        managerIds.map(async (managerId) => {
          try {
            const apiRes = await EmployeeApi.findById(managerId, true);
            const manager = apiRes && apiRes.result ? apiRes.result : null;
            const name = manager
              ? this.fn_getDirectManagerLabel(manager)
              : managerId;
            return [managerId, name];
          } catch (error) {
            console.error("Load direct manager name failed", managerId, error);
            return [managerId, managerId];
          }
        })
      );

      this.directManagerNamesById = directManagerEntries.reduce((acc, [id, name]) => {
        acc[id] = name;
        return acc;
      }, {});
    },
    mouseOver(event,index,type){
      if (this.haveDraff && (this.viewType == 'create' || this.viewType == 'approveInfomation')) return;
      if(type == "avatarImage"){
        //Nếu không có ảnh thì không hiển thị
        if (!this.mData.dataForm.image_id) return;
        this.showButtonDelete = event;
      } else {
        this.mData.fileUploadOption.FileChuKy.listImageSign[index].showButtonDelete = event;
      }
    },
    checkConditionChangeData(field, type) {
      let dataFormByField = _.get(this.mData.dataForm, field);
      let dataDraffByField = _.get(this.dataDraff, field);
      if (
        this.viewType == 'approveInfomation' &&
        this.dataDraff &&
        (
          (type && type == 'date' ? new Date(dataFormByField).getTime() : dataFormByField) !=
          (type && type == 'date' ? new Date(dataDraffByField).getTime(): dataDraffByField)
        )
      ) {
        return true
      } else {
        return false
      }
    },
    checkConditionChangeDataObject(index, keyObj){
      if (!this.dataDraff || this.viewType != 'approveInfomation') return false;
      if (!this.dataDraff[keyObj][index]) {
        return true
      } else {
        let dataChange = window.hash(this.mData.dataForm[keyObj][index]);
        let oldData = window.hash(this.dataDraff[keyObj][index]);
        if (
          dataChange != oldData
        ) {
          return true
        } else {
          return false
        }
      }
    },
    checkConditionChangeDataObjectField(index, keyObj, field, type) {
      if (!this.dataDraff || this.viewType != 'approveInfomation') return false;
      if (!this.dataDraff[keyObj] || !this.dataDraff[keyObj][index] || !this.dataDraff[keyObj][index][field]) {
        return true
      } else {
        // Lấy ra Object của mà mình cần check
        let objChange = this.mData.dataForm[keyObj][index];
        let objDraff = this.dataDraff[keyObj][index];

        // Check nếu không tồn tại 1 trong 2 thì return false
        if (!objChange || !objDraff) return true;

        // Lấy ra giá trị của field cần check
        let dataChange = objChange[field];
        let oldData = objDraff[field];

        // Nếu 2 giá trị khác nhau thì return true
        if (
          (type && type == 'date' ? new Date(dataChange).getTime() : dataChange) !=
          (type && type == 'date' ? new Date(oldData).getTime(): oldData)
        ) {
          return true
        } else {
          return false
        }
      }
    },
    getNameById(id, listKey) {
      let objectByKey = this.mData.dataDefault[listKey].find(item => item.id == id);
      if (objectByKey) {
        return objectByKey.name ? objectByKey.name : ""
      } else {
        return ""
      }
    },
    clearAllValidateStatus() {
      if (this.$refs['myProfileForm']) this.$refs['myProfileForm'].clearValidate()
    },
    removePersonalImage(){
      this.loadPersonalImage = true;
      this.mData.dataForm.PersonalImageUrl = 'img/demo.png';
      this.mData.dataForm.image_id = null;
      this.showButtonDelete = false;
      this.loadPersonalImage = false;
    },
    checkHaveLaborContract() {
      let validJobInfo = this.mData.dataForm.job_info.find(job => {
        return ((new Date(job.start_date).getTime() <= new Date().getTime() && !job.end_date) ||
        (new Date(job.start_date).getTime() <= new Date().getTime() && new Date(job.end_date).getTime() > new Date().getTime())) &&
        job.kind_of_contract == "LABOR";
      })
      if (validJobInfo) {
        this.haveLaborContract = true;
        this.mData.validForm.insurance_book_number = [ValidService.required, ValidService.checkNumber, ValidService.checkMaxLength(20)];
        this.mData.validForm.salary.insurance_salary = [ValidService.required];
        this.mData.validForm.salary.subsidies_salary = [];
        this.mData.dataForm.salary.subsidies_salary.forEach(subsidies_salary => {
          this.mData.validForm.salary.subsidies_salary.push({
            subsidies_salary_type_id: [ValidService.requiredChange],
            value: [ValidService.required]
          })
        });
      } else {
        this.haveLaborContract = false;
        this.mData.validForm.insurance_book_number = [];
        this.mData.validForm.salary.insurance_salary = [];
        this.clearAllValidateStatus();
      }
    },
    fn_getEmployeeStartDateForSeniority() {
      if (this.mData.dataForm.start_work_date) {
        return this.mData.dataForm.start_work_date;
      }
      const startDates = (this.mData.dataForm.job_info || [])
        .filter(item => item && item.start_date)
        .map(item => item.start_date)
        .sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
      return startDates[0];
    },
    fn_updateSeniority() {
      this.calculateSeniority(this.fn_getEmployeeStartDateForSeniority());
    },
    calculateSeniority(date){
      this.showSeniority = false;
      if (!date) {
        this.mData.dataForm.seniority = 0;
      } else {
        let dateNow = moment(new Date());
        let dateTimeStart = moment(date);
        this.mData.dataForm.seniority = Math.floor(dateNow.diff(dateTimeStart, 'years', true) < 0 ? 0 : dateNow.diff(dateTimeStart, 'years', true))
      }
      this.showSeniority = true;
    },
    checkStatusVsGender(type){
      if (type == "status") {
        if (this.mData.dataForm.status == 'NGHI_SINH') {
          this.mData.dataDefault.listGioiTinh = [
            {
              value: 0,
              label: "Nữ"
            },
            {
              value: 2,
              label: "Khác"
            }
          ];
          if (this.mData.dataForm.administrative_info.gender == 1) {
            this.mData.dataForm.administrative_info.gender = undefined;
          }
        } else {
          this.mData.dataDefault.listGioiTinh = DataService.listGioiTinh;
        }
      } else {
        if (this.mData.dataForm.administrative_info.gender == 1) {
          this.mData.dataDefault.listTrangThai = [
            {
              value: "DANG_LAM_VIEC",
              label: "Đang làm việc"
            },
            {
              value: "DA_NGHI",
              label: "Đã nghỉ"
            }
          ];
          if (this.mData.dataForm.status == "NGHI_SINH") {
            this.mData.dataForm.status = "DANG_LAM_VIEC";
          }

        } else {
          this.mData.dataDefault.listTrangThai = DataService.listTrangThaiLamViec;
        }
      }
    },
    formatDate(value) {
      return MethodService.formatDate(value, "date");
    },
    async sendInformationDataRequest(){

      this.$refs["myProfileForm"].validate(async (valid,objectError) => {
        if (valid) {
          await this.sendDataSignatureRequest();
          let dataSendAprove = this.mData.dataForm;
          dataSendAprove.employee_id = this.$router.currentRoute.params.id;
          dataSendAprove.administrative_info.name.full_name = dataSendAprove.administrative_info.name.last_name + ' ' + dataSendAprove.administrative_info.name.first_name;
          delete dataSendAprove.shift;
          let res;
          if (!this.haveDraff) {
            //Thêm mới draff
            delete dataSendAprove.id;
            dataSendAprove.approver = null;
            res = await EmployeeDraffApi.create(dataSendAprove);
          } else {
            //Cập nhật draff
            dataSendAprove.id = this.mData.dataForm.id;
            res = await EmployeeDraffApi.update(dataSendAprove);
          }
          if (res.result) {
            window.toastr.success("Gửi thông tin cập nhật thành công");
            await this.fn_getDataById(this.$router.currentRoute.params.id);
            if (!this.haveDraff) this.mData.haveDraff = true;
            EventBus.$emit('changeEmployeeDraff', {});
            this.$emit("statusSubmit", {
              status: true
            });
          } else {
            window.toastr.error("Gửi thông tin cập nhật thất bại");
          }
        } else {
          let arrKey = Object.keys(objectError);
          if (arrKey.length > 0) {
            if (this.$refs[arrKey[0]].length > 0) {
              this.$refs[arrKey[0]][0].$el.scrollIntoView({ behavior: "smooth", block: "start" });
              setTimeout(() => {
                this.$refs[arrKey[0]][0].focus();
              }, 500);
            } else {
              this.$refs[arrKey[0]].$el.scrollIntoView({ behavior: "smooth", block: "start" });
              setTimeout(() => {
                this.$refs[arrKey[0]].focus();
              }, 500);
            }
          }
          MethodService.stopLadda();
          return false;
        }
      })
    },

    async sendDataSignatureRequest() {
      const imageIds = (this.mData.dataForm.image_ids || []).filter(id => !!id);
      if (imageIds.length === 0 && !this.mData.dataFormEmployeeSignatureDraff) {
        return;
      }

      let dataSendAproveSignature;
      if (this.mData.dataFormEmployeeSignatureDraff) {
        dataSendAproveSignature = MethodService.copyObject(this.mData.dataFormEmployeeSignatureDraff);
      } else {
        dataSendAproveSignature = {
          image_ids: imageIds,
          employee_id: this.$router.currentRoute.params.id,
          approver: null,
          company_id: MethodService.getCompanyInfo().id
        };
      }
      dataSendAproveSignature.image_ids = imageIds;
      dataSendAproveSignature.employee_id = this.$router.currentRoute.params.id;
      let resSignature;
      if (!this.mData.dataFormEmployeeSignatureDraff) {
        resSignature = await EmployeeSignatureDraffApi.create(dataSendAproveSignature);
      } else {
        resSignature = await EmployeeSignatureDraffApi.update(dataSendAproveSignature);
      }
      if (resSignature.result) {
        this.mData.dataFormEmployeeSignatureDraff = resSignature.result;
        this.mData.dataForm.image_ids = imageIds;
        this.fn_syncSignaturePreviewFromImageIds();
        if (!this.haveDraff) this.mData.haveDraff = true;
        EventBus.$emit('changeEmployeeDraff', {});
      }
    },
    async fn_innitDataDefault() {
      this.userProfile = MethodService.getUserProfile();
      this.currentUser = MethodService.getCurrentUser();
      this.companyInfo = MethodService.getCompanyInfo();
      let currentTime = moment(new Date()).format("yyyy-MM-DD")

      const shiftApiReq = ShiftApi.list({
        filters: this.arrShiftIds.length > 0 ? `applied_end_time>=${currentTime}|id:in:${this.arrShiftIds}` : `applied_end_time>=${currentTime}`,
        limit: 999999,
      })
      const contractTypeApiReq = ContractTypeApi.list({
        filters: this.arrContractTypeIds.length > 0 ? `disabled!=true|id:in:${this.arrContractTypeIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const branchApiReq = BranchApi.list({
        filters: this.arrBranchIds.filter(id => id !== null && id !== undefined && id !== '').length > 0 ? `disabled!=true|id:in:${this.arrBranchIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const departmentApiReq = DepartmentApi.list({
        filters: this.arrDepartmentIds.filter(id => id !== null && id !== undefined && id !== '').length > 0 ? `disabled!=true|id:in:${this.arrDepartmentIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const positionApiReq = PositionApi.list({
        filters: this.arrPositionIds.length > 0 ? `disabled!=true|id:in:${this.arrPositionIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const qualificationApiReq = QualificationApi.list({
        filters: this.arrQualificationIds.length > 0 ? `disabled!=true|id:in:${this.arrQualificationIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const majorApiReq = MajorApi.list({
        filters: this.arrMajorIds.length > 0 ? `disabled!=true|id:in:${this.arrMajorIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const relationshipApReq = RelationshipApi.list({
        filters: this.arrRelationshipIds.length > 0 ? `disabled!=true|id:in:${this.arrRelationshipIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const coefficientSalaryApiReq = CoefficientSalaryApi.list({
        filters: this.arrCoefficientSalaryIds.length > 0 ? `disabled!=true|id:in:${this.arrCoefficientSalaryIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const rankSalaryApiReq = RankSalaryApi.list({
        filters: this.arrRankSalaryIds.length > 0 ? `disabled!=true|id:in:${this.arrRankSalaryIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)
      const subsidiesSalaryTypeApiReq = SubsidiesSalaryTypeApi.list({
        filters: this.arrSubsidiesSalaryTypeIds.length > 0 ? `disabled!=true|id:in:${this.arrSubsidiesSalaryTypeIds}` : `disabled!=true`,
        sort: 'company_id',
        limit: 999999,
      }, true)

      const shiftApiRes = await shiftApiReq;
      const contractTypeApiRes = await contractTypeApiReq;
      const branchApiRes = await branchApiReq;
      const departmentApiRes = await departmentApiReq;
      const positionApiRes = await positionApiReq;
      const qualificationApiRes = await qualificationApiReq;
      const majorApiRes = await majorApiReq;
      const relationshipApRes = await relationshipApReq;
      const coefficientSalaryApiRes = await coefficientSalaryApiReq;
      const rankSalaryApiRes = await rankSalaryApiReq;
      const subsidiesSalaryTypeApiRes = await subsidiesSalaryTypeApiReq;

      this.mData.dataDefault.listCaLamViec = shiftApiRes.result;
      this.mData.dataDefault.listLoaiHopDong = contractTypeApiRes.result;
      this.mData.dataDefault.listChiNhanh = branchApiRes.result;
      this.mData.dataDefault.listPhongBan = departmentApiRes.result;
      this.mData.dataDefault.listChucVu = positionApiRes.result;
      this.mData.dataDefault.listTrinhDo = qualificationApiRes.result;
      this.mData.dataDefault.listChuyenNganh = majorApiRes.result;
      this.mData.dataDefault.listMoiQuanHe = relationshipApRes.result;
      this.mData.dataDefault.listHeSoLuong = coefficientSalaryApiRes.result;
      this.mData.dataDefault.listBacLuong = rankSalaryApiRes.result;
      this.mData.dataDefault.listTroCap = subsidiesSalaryTypeApiRes.result;
    },
    async approveDraff(type) {
      try {
        let res;
        if (type == 'approve') {
          res = await EmployeeDraffApi.ApproveEmployeeAsync({
            id: this.$router.currentRoute.params.id
          });

        } else {
          res = await EmployeeDraffApi.UnApproveEmployeeAsync({
            id: this.$router.currentRoute.params.id
          });
        }
        if (res.result) {
          window.toastr.success(`${type == 'approve' ? 'Duyệt' : 'Từ chối'} thông tin thành công`);
          EventBus.$emit('approveEmployeeDraff', {});
        } else {
          window.toastr.error(`${type == 'approve' ? 'Duyệt' : 'Từ chối'} thông tin không thành công`);
        }
      } catch (error) {
        window.toastr.error(`Có lỗi xảy ra trong quá trình ${type == 'approve' ? 'Dduyệt' : 'từ chối'} thông tin. Vui lòng thử lại!`);
      }
    },
    async fn_getDataById(id) {
      this.loading = true;
      this.mData.dataDefault.listShiftValidTime = [];
      this.mData.dataDefault.listSocialMediaNetwork = DataService.listSocialMediaNetwork;
      this.checkEnoughSocialNetwork = false;
      this.mData.haveHistoryShift = false;
      this.mData.shiftRemove = [];
      this.mData.fileUploadOption.Anh.fileList = [];
      this.mData.fileUploadOption.FileHoSo.fileList = [];
      this.mData.fileUploadOption.MatTruocCMND.fileList = [];
      this.mData.fileUploadOption.MatSauCMND.fileList = [];
      this.mData.fileUploadOption.FileChuKy.listImageSign = [];
      this.signaturePreviewImage = null;
      this.applyFullNameValidation();
      let employeeApiRes = await EmployeeApi.findById(id);
      let employeeShiftApiRes = await EmployeeShiftApi.list(
        {
          filters: "employee_id=" + id,
        },
        true
      );

      let employeeSignatureApiRes = await EmployeeSignatureApi.list({
        filters: "employee_id=" + id,
      }, true);
      let employeeSignatureDraffApiRes = await EmployeeSignatureDraffApi.list({
        filters: `employee_id=${id}&approver:is_null:true`,
        }, true);

      if (employeeApiRes.result) {
        if (this.viewType == 'create') {
            this.mData.dataForm = employeeApiRes.result;
        } else {
          if (this.dataDraff) {
            this.mData.dataForm = MethodService.copyObject(this.dataDraff);
          } else {
            this.mData.dataForm = MethodService.copyObject(employeeApiRes.result);
          }
          this.dataDraff = employeeApiRes.result;
        }
        this.syncEmployeeFullNameInput();
        await this.fn_loadDirectManagerNames();
        this.fn_updateSeniority();
        if (this.mData.dataForm.administrative_info.avatar_id) {
          this.loadImage = true;
          let data = {
            id: this.mData.dataForm.administrative_info.avatar_id,
            name: this.mData.dataForm.administrative_info.avatar_id,
            url:
              ExtensionService.urlImg +
              this.mData.dataForm.administrative_info.avatar_id,
          };
          this.mData.dataForm.avatarUrl = data.url;
          this.mData.fileUploadOption.Anh.fileList.push(data);
          setTimeout(() => {
            this.loadImage = false;
          }, 50);
          this.haveAvatar = true;
        } else {
          this.mData.dataForm.avatarUrl = "img/demo.png";
        }
        if (this.mData.dataForm.image_id) {
          let data = {
            id: this.mData.dataForm.image_id,
            name: this.mData.dataForm.image_id,
            url:
              ExtensionService.urlImg +
              this.mData.dataForm.image_id,
          };
          this.mData.dataForm.PersonalImageUrl = data.url;
          this.mData.fileUploadOption.AnhCaNhan.fileList.push(data);
          this.haveAvatar = true;
        } else {
          this.mData.dataForm.PersonalImageUrl = "img/demo.png";
        }
        if (
          this.mData.dataForm.file_ids &&
          this.mData.dataForm.file_ids.length > 0
        ) {
          let listFile = await FileApi.list(
            {
              limit: this.mData.dataForm.file_ids.length,
              filters: "id:in:" + this.mData.dataForm.file_ids.join(","),
            },
            true
          );
          let data = [];
          if (listFile && listFile.result) {
            data = listFile.result;
            data.map((item) => {
              item.url = ExtensionService.urlImg + item.id;
            });
          }
          this.mData.fileUploadOption.FileHoSo.fileList = data;
        } else {
          this.mData.fileUploadOption.FileHoSo.fileList = [];
        }

        if (this.mData.dataForm.administrative_info.identify_before_img_id) {
          let data = {};
          let file = await FileApi.findById(
            this.mData.dataForm.administrative_info.identify_before_img_id
          );
          data = file.result;
          this.mData.fileUploadOption.MatTruocCMND.fileList.push(data);
        } else {
          this.mData.fileUploadOption.MatTruocCMND.fileList = [];
        }

        if (this.mData.dataForm.administrative_info.identify_after_img_id) {
          let data = {};
          let file = await FileApi.findById(
            this.mData.dataForm.administrative_info.identify_after_img_id
          );
          data = file.result;
          this.mData.fileUploadOption.MatSauCMND.fileList.push(data);
        } else {
          this.mData.fileUploadOption.MatSauCMND.fileList = [];
        }

        if (this.mData.dataForm.card_no) {
          this.mData.isHaveTheChamCong = true;
        } else {
          this.mData.isHaveTheChamCong = false;
        }

        if (employeeShiftApiRes.result) {
          // this.mData.dataForm.shift = employeeShiftApiRes.result;
          this.mData.dataForm.shift = employeeShiftApiRes.result.sort(function (a,b) {
            return (
              new Date(a.created_at).getTime() -
              new Date(b.created_at).getTime()
            );
          });
          this.mData.validForm.shift = [];
          this.mData.dataForm.shift.forEach((item) => {
            if (item.end_time) {
              if (new Date(item.end_time).getTime() <= new Date().getTime()) {
                item.expiredShift = true;
                this.mData.haveHistoryShift = true;
              }
            }
            // item.key = Math.random().toString(36).substring(2);
            item.key_dataSave = true;
            this.mData.validForm.shift.push(EmployeeModel.validShift);
          });
        } else {
          this.mData.dataForm.shift = [];
        }

        this.arrShiftIds = []
        this.mData.dataForm.shift.forEach(e => {
          this.arrShiftIds.push(e.shift_id)
          if (!e.expiredShift) {
            this.mData.dataDefault.listShiftValidTime.push(e)
          }
        })

        if (!this.mData.dataForm.file_ids) {
          this.mData.dataForm.file_ids = [];
        }

        //Chữ ký nhân viên
        this.fn_loadEmployeeSignatureData(
          employeeSignatureApiRes.result,
          employeeSignatureDraffApiRes.result
        );

        this.arrMajorIds = []
        this.arrQualificationIds = []
        this.mData.validForm.qualification = []
        if (
          this.mData.dataForm.qualification &&
          this.mData.dataForm.qualification.length > 0
        ) {
          this.mData.dataForm.qualification.forEach((item) => {
            item.key = Math.random().toString(36).substring(2)
            this.mData.validForm.qualification.push(EmployeeModel.validQualification)
            this.arrMajorIds.push(item.major_id)
            this.arrQualificationIds.push(item.qualification_id)
          })
          this.activeName2 = 'box-card-qualification'
        } else {
          this.activeName2 = 'box-card-qualification1'
          this.mData.dataForm.qualification = Array()
        }
        this.arrRelationshipIds = []
        this.mData.validForm.other_contact_info = []
        if (
          this.mData.dataForm.other_contact_info &&
          this.mData.dataForm.other_contact_info.length > 0
        ) {
          this.mData.dataForm.other_contact_info.forEach((item) => {
            item.key = Math.random().toString(36).substring(2)
            this.mData.validForm.other_contact_info.push(
              EmployeeModel.validOtherContactInfo
            )
            this.arrRelationshipIds.push(item.relationship_id)
          })
          this.activeName4 = 'box-card-other-contact-information'
        } else {
          this.activeName4 = 'box-card-other-contact-information1'
          this.mData.dataForm.other_contact_info = Array()
        }
        this.arrContractTypeIds = []
        this.arrBranchIds = []
        this.arrDepartmentIds = []
        this.arrPositionIds = []
        this.mData.validForm.job_info = []
        this.mData.dataForm.job_info.forEach((item) => {
          item.key = Math.random().toString(36).substring(2)
          if (item.official_labor_contract_signed_date === undefined) {
            this.$set(item, 'official_labor_contract_signed_date', null)
          }
          this.mData.validForm.job_info.push(EmployeeModel.validJobInfo)
          this.arrBranchIds.push(item.branch_id)
          this.arrContractTypeIds.push(item.contract_type_id)
          this.arrDepartmentIds.push(item.department_id)
          this.arrPositionIds.push(item.position_id)
        })

        this.mData.validForm.certificate = []
        if (
          this.mData.dataForm.certificate &&
          this.mData.dataForm.certificate.length > 0
        ) {
          this.mData.dataForm.certificate.forEach((item) => {
            item.key = Math.random().toString(36).substring(2)
            this.mData.validForm.certificate.push(
              EmployeeModel.validCertificate
            )
          })
          this.activeName3 = 'box-card-certificate'
        } else {
          this.activeName3 = 'box-card-certificate1'
          this.mData.dataForm.certificate = Array()
        }

        this.mData.validForm.dependent_person_info = []
        if (
          this.mData.dataForm.dependent_person_info &&
          this.mData.dataForm.dependent_person_info.length > 0
        ) {
          this.mData.dataForm.dependent_person_info.forEach((item) => {
            item.key = Math.random().toString(36).substring(2)
            this.mData.validForm.dependent_person_info.push(
              EmployeeModel.validDependentPersonInfo
              )
            this.arrRelationshipIds.push(item.relationship_id)
          })
          this.activeName6 = 'box-card-dependent-person'
        } else {
          this.activeName6 = 'box-card-dependent-person1'
          this.mData.dataForm.dependent_person_info = []
        }

        if (!this.mData.dataForm.salary) {
          this.mData.dataForm.salary = MethodService.copyObject(EmployeeModel.dataForm).salary
        }
        this.mData.validForm.salary.subsidies_salary = []

        this.arrCoefficientSalaryIds = []
        this.arrRankSalaryIds = []
        if (
          this.mData.dataForm.salary &&
          (this.mData.dataForm.salary.payment_method ||
          this.mData.dataForm.salary.bank_name ||
          this.mData.dataForm.salary.bank_account ||
          this.mData.dataForm.salary.bank_branch ||
          this.mData.dataForm.salary.coefficient_salary_id ||
          this.mData.dataForm.salary.rank_salary_id ||
          this.mData.dataForm.salary.gross_salary ||
          this.mData.dataForm.salary.insurance_salary)
        ) {
          this.activeName5 = 'box-card-salary'
          if (this.mData.dataForm.salary.gross_salary)  this.mData.dataForm.salary.gross_salary = this.mData.dataForm.salary.gross_salary.toString()
          if (this.mData.dataForm.salary.insurance_salary)  this.mData.dataForm.salary.insurance_salary = this.mData.dataForm.salary.insurance_salary.toString()
          if (this.mData.dataForm.salary.coefficient_salary_id) this.arrCoefficientSalaryIds.push(this.mData.dataForm.salary.coefficient_salary_id)
          if (this.mData.dataForm.salary.rank_salary_id) this.arrRankSalaryIds.push(this.mData.dataForm.salary.rank_salary_id)
        } else {
          this.activeName5 = 'box-card-salary1'
        }
        this.arrSubsidiesSalaryTypeIds = []
        if (
          this.mData.dataForm.salary &&
          this.mData.dataForm.salary.subsidies_salary &&
          this.mData.dataForm.salary.subsidies_salary.length > 0
          ) {
          this.mData.dataForm.salary.subsidies_salary.forEach((item) => {
            if (item.value) item.value = item.value.toString()
            item.key = Math.random().toString(36).substring(2)
            this.mData.validForm.salary.subsidies_salary.push(EmployeeModel.validSubsidiesSalary)
            this.arrSubsidiesSalaryTypeIds.push(item.subsidies_salary_type_id)
            if (item.subsidies_salary_type_id || item.value) {
              this.activeName5 = 'box-card-salary'
            }
          })
        } else {
          this.addRow()
        }
        if (!this.mData.dataForm.social_networks) {
          this.mData.dataForm.social_networks = []
        } else {
          this.checkAndRemoveTypeSocialNetWork()
        }
        this.checkHaveLaborContract()
        this.clearAllValidateStatus()
        this.$forceUpdate()
        setTimeout(() => {
          this.loading = false
          this.fn_innitDataDefault()
        }, 1500)
      } else {
        window.toastr.error("Nhân viên không tồn tại!");
        this.$router.push({
          name: "Admin-EmployeeManager-list",
        });
      }
    },
    async fn_uploadChangeFile(file, fileList) {
      if (file && file.name) {
        let lastIndexOfDot = file.name.lastIndexOf(".");
        let fileType = file.name.substr(lastIndexOfDot + 1, file.name.length);
        let typeImage = ["png", "jpg", "jpeg"];
        if (!typeImage.includes(fileType.toLowerCase())) {
          window.toastr.error("Ảnh phải có định dạng là png, jpg hoặc jpeg");
          this.mData.fileUploadOption.Anh.fileList = [];
          return;
        }
      }
      if (!this.checkFileSize(file.size)){
        window.toastr.warning('Ảnh tải lên có dung lương không quá 10MB')
        this.mData.fileUploadOption.Anh.fileList = []
        return
      }
      ExtensionService.upload(file, "fileNhanVien")
        .then((res) => {
          this.loadImage = true;
          this.mData.dataForm.administrative_info.avatar_id = res.result;
          this.mData.dataForm.avatarUrl = ExtensionService.urlImg + res.result;
          this.loadImage = false;
          this.haveAvatar = true;
          this.mData.fileUploadOption.Anh.fileList = fileList;
          this.$refs["myProfileForm"].clearValidate(
            "administrative_info.avatar_id"
          );
          // this.$refs["myProfileForm"].validateField('administrative_info.avatar_id');
          if (this.mData.dataForm.administrative_info.avatar_id) {
            this.mData.validForm.administrative_info.avatar_id = [];
          }
          // this.$refs["myProfileForm"].validateField('administrative_info.avatar_id');
        })
        .catch((error) => {
          this.mData.validForm.administrative_info.avatar_id = [
            ValidService.requiredChange,
          ];
          this.$refs["myProfileForm"].clearValidate(
            "administrative_info.avatar_id"
          );
          // this.$refs["myProfileForm"].validateField('administrative_info.avatar_id');
          window.toastr.error("Có lỗi xảy ra, vui lòng thử lại!");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    checkTypeImagae(fileName){
      let lastIndexOfDot = fileName.lastIndexOf(".");
      let fileType = fileName.substr(lastIndexOfDot + 1, fileName.length);
      let typeImage = ["png", "jpg", "jpeg"];
      if (!typeImage.includes(fileType.toLowerCase())) {
        return false
      } else {
        return true
      }
    },
    checkFileSize(fileSize) {
      let fileSizeMb = fileSize / 1024 / 1024
      if (fileSizeMb > 10) return false
      return true
    },
    async fn_uploadChangePersonalImage(file, fileList) {
      if (!this.checkTypeImagae(file.name)){
        window.toastr.error("Ảnh phải có định dạng là png, jpg hoặc jpeg");
        this.mData.fileUploadOption.AnhCaNhan.fileList = [];
        return;
      }
      if (!this.checkFileSize(file.size)){
        window.toastr.warning('Ảnh tải lên có dung lương không quá 10MB')
        this.mData.fileUploadOption.AnhCaNhan.fileList = []
        return
      }
      ExtensionService.upload(file, "anhCaNhanNhanVien")
        .then((res) => {
          this.loadPersonalImage = true;
          this.mData.dataForm.image_id = res.result;
          this.mData.dataForm.PersonalImageUrl = ExtensionService.urlImg + res.result;
          this.haveAvatar = true;
          this.mData.fileUploadOption.AnhCaNhan.fileList = fileList;
          this.loadPersonalImage = false;
        })
        .catch((error) => {
          this.loadPersonalImage = false;
          window.toastr.error("Có lỗi xảy ra, vui lòng thử lại!");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    async fn_uploadFile(file, fileList) {
      ExtensionService.upload(file, "HoSo")
        .then((res) => {
          this.mData.dataForm.file_ids.push(res.result);
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.FileHoSo.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_downloadFile(file) {
      window.open(ExtensionService.urlDowloadFile + file.id);
    },
    fn_removeFile(file, fileList) {
      let data = fileList.map((el) => el.id);
      this.mData.dataForm.file_ids = data;
    },


    //Chữ ký nhân viên
    fn_syncSignaturePreviewFromImageIds() {
      const imageIds = (this.mData.dataForm.image_ids || []).filter(id => !!id);
      if (imageIds.length === 0) {
        this.signaturePreviewImage = null;
        this.mData.fileUploadOption.FileChuKy.listImageSign = [];
        return;
      }
      const firstId = imageIds[0];
      this.signaturePreviewImage = {
        id: firstId,
        url: ExtensionService.urlImg + firstId
      };
      this.mData.fileUploadOption.FileChuKy.listImageSign = [this.signaturePreviewImage];
    },
    fn_applyEmployeeSignatureRecord(signatureRecord, options = {}) {
      const { isDraft = false } = options;
      if (!signatureRecord) return;
      if (!Array.isArray(signatureRecord.image_ids)) {
        signatureRecord.image_ids = [];
      }
      const imageIds = signatureRecord.image_ids.filter(id => !!id);
      if (isDraft) {
        this.mData.dataFormEmployeeSignatureDraff = signatureRecord;
      }
      this.mData.dataFormEmployeeSignature = signatureRecord;
      this.mData.dataForm.image_ids = imageIds;
      this.activeName7 = imageIds.length > 0 ? "box-card-sign" : "box-card-sign1";
      this.fn_syncSignaturePreviewFromImageIds();
    },
    fn_loadEmployeeSignatureData(signatureApiResult, signatureDraffApiResult) {
      this.mData.fileUploadOption.FileChuKy.listImageSign = [];
      this.signaturePreviewImage = null;

      const signatureDraff = signatureDraffApiResult && signatureDraffApiResult.length > 0
        ? signatureDraffApiResult[0]
        : null;
      const signatureApproved = signatureApiResult && signatureApiResult.length > 0
        ? signatureApiResult[0]
        : null;

      if (this.dataSignatureDraff) {
        this.fn_applyEmployeeSignatureRecord(this.dataSignatureDraff, { isDraft: true });
        return;
      }

      if (signatureDraff) {
        this.fn_applyEmployeeSignatureRecord(signatureDraff, { isDraft: true });
        return;
      }

      if (signatureApproved) {
        this.fn_applyEmployeeSignatureRecord(signatureApproved, { isDraft: false });
        return;
      }

      this.mData.dataFormEmployeeSignature = [];
      this.mData.dataForm.image_ids = [];
      this.activeName7 = "box-card-sign1";
    },
    fn_canEditSignature() {
      return !(
        (this.haveDraff && (this.viewType == "create" || this.viewType == "approveInfomation")) ||
        this.mData.viewMode == "detail"
      );
    },
    fn_getFirstSignImage() {
      return this.signaturePreviewImage;
    },
    checkTypeImageBeforeUpload(file) {
      if (file.raw && file.raw.type == "image/png") {
        return true;
      } else {
        toastr.warning("Chỉ được tải lên file ảnh có định dạng PNG");
        return false;
      }
    },
    async fn_uploadSign(file, fileList) {
      if (!this.checkTypeImageBeforeUpload(file)) return
      const res = await ExtensionService.upload(file, "ChuKyNhanVien");
      if (res && res.result) {
        let resultCheck = await MethodService.checkWidthHeightImage(res.result, 220, 220);
        if (!resultCheck.status) {
          toastr.warning(resultCheck.message ? resultCheck.message : "Kích thước ảnh không hợp lệ");
          return;
        }
        this.mData.dataForm.image_ids = [res.result];
        this.signaturePreviewImage = {
          id: res.result,
          url: ExtensionService.urlImg + res.result
        };
        this.mData.fileUploadOption.FileChuKy.listImageSign = [this.signaturePreviewImage];
      }
    },
    fn_removeSignImage(imageId){
      this.mData.dataForm.image_ids = [];
      this.mData.fileUploadOption.FileChuKy.listImageSign = [];
      this.signaturePreviewImage = null;
      if (this.mData.dataFormEmployeeSignatureDraff) {
        this.mData.dataFormEmployeeSignatureDraff.image_ids = [];
      }
    },
    clearValidateStatus(colection, fieldList, index){
      fieldList.forEach(field => {
        this.$refs["myProfileForm"].clearValidate(
          `${colection}[${index}].${field}`
        )
      })
    },
    //Trình độ chuyên môn
    newQualification() {
      let dataAdd = MethodService.copyObject(EmployeeModel.dataQualification);
      dataAdd.key = Math.random().toString(36).substring(2);
      dataAdd.type = "add";
      if (!this.mData.dataForm.qualification) this.mData.dataForm.qualification = [];
      this.mData.dataForm.qualification.push(dataAdd);
      this.mData.validForm.qualification.push(
        EmployeeModel.validQualification
      );
      this.forceUpdateUI();
    },
    removeQualification(key) {
      let data = this.mData.dataForm.qualification.filter(
        (el) => el.key !== key
      );
      this.mData.dataForm.qualification = data;
      this.forceUpdateUI();
      setTimeout(() => {
        this.clearValidateStatus('qualification', ['qualification_id','major_id','issued_by','issued_date'],index);
      }, 100);
    },

    //Chứng chỉ
    newCertificate() {
      let dataAdd = MethodService.copyObject(EmployeeModel.dataCertificate);
      dataAdd.key = Math.random().toString(36).substring(2);
      dataAdd.type = "add";
      if (!this.mData.dataForm.certificate) this.mData.dataForm.certificate = [];
      this.mData.dataForm.certificate.push(dataAdd);
      this.mData.validForm.certificate.push(EmployeeModel.validCertificate);
      this.forceUpdateUI();
    },
    removeCertificate(key) {
      let data = this.mData.dataForm.certificate.filter((el) => el.key !== key);
      this.mData.dataForm.certificate = data;
      this.forceUpdateUI();
      setTimeout(() => {
        this.clearValidateStatus('certificate', ['name','issued_by','issued_date'],index);
      }, 100);
    },

    //Thông tin liên hệ khác
    newOtherContactInformation() {
      let dataAdd = MethodService.copyObject(
        EmployeeModel.dataOtherContactInfo
      );
      dataAdd.key = Math.random().toString(36).substring(2);
      dataAdd.type = "add";
      if (!this.mData.dataForm.other_contact_info) this.mData.dataForm.other_contact_info = [];
      this.mData.dataForm.other_contact_info.push(dataAdd);
      this.mData.validForm.other_contact_info.push(
        EmployeeModel.validOtherContactInfo
      );
      this.forceUpdateUI();
    },
    removeOtherContactInformation(key) {
      let data = this.mData.dataForm.other_contact_info.filter(
        (el) => el.key !== key
      );
      this.mData.dataForm.other_contact_info = data;
      this.forceUpdateUI();
      setTimeout(() => {
        this.clearValidateStatus('other_contact_info', ['full_name','relationship_id','phone_number'],index);
      }, 100);
    },

    //Thông tin người phụ thuộc
    newDependentPerson() {
      let dataAdd = MethodService.copyObject(
        EmployeeModel.dataDependentPersonInfo
      );
      dataAdd.key = Math.random().toString(36).substring(2);
      dataAdd.type = "add";
      if (!this.mData.dataForm.dependent_person_info) this.mData.dataForm.dependent_person_info = [];
      this.mData.dataForm.dependent_person_info.push(dataAdd);
      this.mData.validForm.dependent_person_info.push(
        EmployeeModel.validDependentPersonInfo
      );
      this.forceUpdateUI();
    },
    removeDependentPerson(key) {
      let data = this.mData.dataForm.dependent_person_info.filter(
        (el) => el.key !== key
      );
      this.mData.dataForm.dependent_person_info = data;
      this.forceUpdateUI();
      setTimeout(() => {
        this.clearValidateStatus('dependent_person_info', ['full_name','relationship_id','registered_date'],index);
      }, 100);
    },

    //
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_resetForm() {
      this.mData.fileUploadOption.Anh = {
        limit: 1,
        accept: ".jpg, .png, .jpeg",
        dialogImageUrl: "",
        dialogVisible: false,
        fileList: [],
      };
      this.$refs["myProfileForm"].resetFields();
      this.mData.isHaveTheChamCong = false;
      this.mData.dataForm.card_no = "";
      this.mData.dataForm.shift = [];
      this.mData.dataForm.job_info = [];
      this.mData.dataForm.qualification = [];
      this.mData.dataForm.certificate = [];
      this.mData.dataForm.other_contact_info = [];
      this.mData.dataForm.dependent_person_info = [];
      this.mData.dataForm.salary.subsidies_salary = [];
    },
    setDisableTime(index) {
      if (!this.mData.dataForm.shift[index].shift_id) {
        this.pickerOptions = {
          disabledDate(time) {
            return time.getTime() <= new Date().getTime();
          },
        };
      } else {
        let shift = this.mData.dataDefault.listCaLamViec.find((item) => {
          return item.id == this.mData.dataForm.shift[index].shift_id;
        });
        let start = shift.applied_start_time;
        let end = shift.applied_end_time;
        let now = new Date();
        let timeStartDisable = "";
        if (new Date(start).getTime() > new Date(now).getTime()) {
          timeStartDisable = start;
        } else if (new Date(start).getTime() < new Date(now).getTime()) {
          timeStartDisable = now;
        }
        this.pickerOptions = {
          disabledDate(time) {
            return (
              time.getTime() > new Date(end).getTime() ||
              time.getTime() < new Date(timeStartDisable).getTime()
            );
          },
        };
      }
    },
    changeShift(index, shiftId) {
      let checkDuplicateShift = undefined;
      if (this.mData.viewMode != "create") {
        checkDuplicateShift = this.mData.dataDefault.listShiftValidTime.filter((e,i) => {
          return e.shift_id && e.shift_id == shiftId && !e.expiredShift
        });
      } else if (this.mData.viewMode == "create") {
        checkDuplicateShift = this.mData.dataDefault.listShiftValidTime.filter((e,i) => {
          return e.shift_id && e.shift_id == shiftId
        });
      }
      if (checkDuplicateShift && checkDuplicateShift.length > 0) {
        this.mData.dataForm.shift[index].shift_id = undefined;
        this.mData.dataDefault.listShiftValidTime = MethodService.copyObject(this.mData.dataForm.shift);
        window.toastr.error("Không được chọn trùng lặp ca!");
        this.$nextTick(() => this.$refs["shiftId"][index].focus());
        this.loadShift = true;
        return
      }
      this.loadShift = false;
      this.mData.dataDefault.listShiftValidTime = MethodService.copyObject(this.mData.dataForm.shift);
      this.mData.dataForm.shift[index].start_time = undefined;
      this.loadTimeStart = false;
      setTimeout(() => {
        this.loadTimeStart = true;
      }, 0.000001);

      let shiftInfor = this.mData.dataDefault.listCaLamViec.find((e) => {
        return e.id == shiftId;
      });
      if (shiftInfor && shiftInfor.applied_end_time) {
        let time = new Date(shiftInfor.applied_end_time);
        let time39h59 = new Date(
          time.getFullYear(),
          time.getMonth(),
          time.getDate(),
          23,
          59,
          59
        );
        this.mData.dataForm.shift[index].end_time = time39h59;
      }
      setTimeout(() => {
        this.loadShift = true;
      }, 0.00000000001);
    },

    changeTimeStart(index) {
      this.loadTimeStart = false;
      if (this.mData.dataForm.shift[index].end_time) {
        if (
          new Date(this.mData.dataForm.shift[index].start_time).getTime() >
          new Date(this.mData.dataForm.shift[index].end_time).getTime()
        ) {
          window.toastr.warning(
            "Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu"
          );
          this.$refs["timeEnd"][index].focus();
        }
      }
      setTimeout(() => {
        this.loadTimeStart = true;
      }, 0.01);
    },

    changeTimeEnd(index) {
      if (this.mData.dataForm.shift[index].end_time) {
        if (
          new Date(this.mData.dataForm.shift[index].start_time).getTime() >
          new Date(this.mData.dataForm.shift[index].end_time).getTime()
        ) {
          window.toastr.warning(
            "Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu"
          );
          this.$refs["timeEnd"][index].focus();
        }
        let time = new Date(this.mData.dataForm.shift[index].end_time);
        let time39h59 = new Date(
          time.getFullYear(),
          time.getMonth(),
          time.getDate(),
          23,
          59,
          59
        );
        this.mData.dataForm.shift[index].end_time = time39h59;
      }
    },

    changeTimeStartInfomationJod(index) {
      this.loadTimeStartCT = false;
      this.fn_updateSeniority();
      if (this.mData.dataForm.job_info[index].end_date) {
        if (
          new Date(this.mData.dataForm.job_info[index].start_date).getTime() >
          new Date(this.mData.dataForm.job_info[index].end_date).getTime()
        ) {
          window.toastr.warning(
            "Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu"
          );
          this.$refs["timeEndInfomationJod"][index].focus();
        }
      }
      setTimeout(() => {
        this.loadTimeStartCT = true;
      }, 0.01);
    },

    changeTimeEndInfomationJod(index) {
      if (this.mData.dataForm.job_info[index].end_date) {
        if (
          new Date(this.mData.dataForm.job_info[index].start_date).getTime() >
          new Date(this.mData.dataForm.job_info[index].end_date).getTime()
        ) {
          window.toastr.warning(
            "Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu"
          );
          this.$refs["timeEndInfomationJod"][index].focus();
        }
        let time = new Date(this.mData.dataForm.job_info[index].end_date);
        let time39h59 = new Date(
          time.getFullYear(),
          time.getMonth(),
          time.getDate(),
          23,
          59,
          59
        );
        this.mData.dataForm.job_info[index].end_date = time39h59;
      }
    },

    changeTimeStartDependentPerson(index) {
      if (this.mData.dataForm.dependent_person_info[index].expired_date) {
        if (
          new Date(
            this.mData.dataForm.dependent_person_info[index].registered_date
          ).getTime() >
          new Date(
            this.mData.dataForm.dependent_person_info[index].expired_date
          ).getTime()
        ) {
          window.toastr.warning(
            "Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu"
          );
          this.$refs["timeEndDependentPerson"][index].focus();
        }
      }
    },

    changeTimeEndDependentPerson(index) {
      if (this.mData.dataForm.dependent_person_info[index].expired_date) {
        if (
          new Date(
            this.mData.dataForm.dependent_person_info[index].registered_date
          ).getTime() >
          new Date(
            this.mData.dataForm.dependent_person_info[index].expired_date
          ).getTime()
        ) {
          window.toastr.warning(
            "Thời gian kết thúc phải lớn hơn hoặc bằng thời gian bắt đầu"
          );
          this.$refs["timeEndDependentPerson"][index].focus();
        }
        let time = new Date(
          this.mData.dataForm.dependent_person_info[index].expired_date
        );
        let time39h59 = new Date(
          time.getFullYear(),
          time.getMonth(),
          time.getDate(),
          23,
          59,
          59
        );
        this.mData.dataForm.dependent_person_info[index].expired_date =
          time39h59;
      }
    },
    emitGlobalDataChange() {
      let eventName = "changeEmployeeInformation";
      EventBus.$emit(eventName);
    },
    checkAndRemoveTypeSocialNetWork(){
      this.mData.listTypeSocialNetwork = [];
      this.mData.dataDefault.listSocialMediaNetwork = DataService.listSocialMediaNetwork;
      this.mData.dataForm.social_networks.forEach(e => {
        this.mData.listTypeSocialNetwork.push(e.type);
      })
      if (this.mData.dataForm.social_networks.length == 5) {
        this.checkEnoughSocialNetwork = true;
      } else {
        this.checkEnoughSocialNetwork = false;
      }
      if (this.mData.listTypeSocialNetwork.length > 0) {
        this.mData.listTypeSocialNetwork.forEach(x => {
          let a = this.mData.dataDefault.listSocialMediaNetwork.filter(y => y.value != x);
          this.mData.dataDefault.listSocialMediaNetwork = a;
        })
      }
    },
    addNewSocialNetwork(){
      this.typeChangeSocialNetwork = "create";
      this.checkAndRemoveTypeSocialNetWork();
      setTimeout(() => {
        this.visibleDialogSocialNetwork = true;
        // if (this.mData.dataForm.social_networks.length == 5) {
        //   this.checkEnoughSocialNetwork = true;
        // }
      }, 200);
    },
    beforeCloseDialogSocialNetwork(){
      this.$refs['formSocialNetwork'].fields.find((f) => f.prop == "type").resetField();
      this.$refs['formSocialNetwork'].fields.find((f) => f.prop == "url").resetField();
      this.mData.dataDefault.listSocialMediaNetwork = DataService.listSocialMediaNetwork;
      this.mData.dataFormSocialNetWork.url = undefined;
      this.mData.dataFormSocialNetWork.type = undefined;
      this.visibleDialogSocialNetwork = false;
    },
    submitFormSocialNetwork(type){
      this.$refs["formSocialNetwork"].validate(async (valid) => {
        if (valid) {
          let data = {
            url: this.mData.dataFormSocialNetWork.url,
            type: this.mData.dataFormSocialNetWork.type,
            key: Math.random().toString(36).substring(2)
          };
          let nameSocialNetwork = this.mData.dataDefault.listSocialMediaNetwork.find(e => e.type == this.mData.dataFormSocialNetWork.type);
          if (nameSocialNetwork && nameSocialNetwork.label) {
            data.name = nameSocialNetwork.label;
          }
          if (type == "create") {
            this.mData.dataForm.social_networks.push(data);
            if (this.mData.dataForm.social_networks.length == 5)
              this.checkEnoughSocialNetwork = true;
          } else {
            this.mData.dataForm.social_networks.forEach(e => {
              if (e.type == data.type) {
                e.url = data.url
              }
            })
          }
          setTimeout(() => {
            this.beforeCloseDialogSocialNetwork();
          }, 200);
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    goToLinkUrl(url){
      window.open(url, '_blank').focus();
    },
    showDetailImage(url){
      this.urlImage = url;
      setTimeout(() => {
        this.visibleDialogImage = true;
      }, 100);
    },
    addRow() {
      let dataAdd = MethodService.copyObject(EmployeeModel.dataSubsidiesSalary);
      dataAdd.key = Math.random().toString(36).substring(2);
      this.mData.dataForm.salary.subsidies_salary.push(dataAdd);
      if (this.haveLaborContract) {
        this.mData.validForm.salary.subsidies_salary.push({
          subsidies_salary_type_id: [ValidService.requiredChange],
          value: [ValidService.required]
        });
      } else {
        this.mData.validForm.salary.subsidies_salary.push(
          EmployeeModel.validSubsidiesSalary
        );
      }
      this.forceUpdateUI();
    },
    closeViewer() {
      this.visibleDialogImage = false;
    },
    updateSocialNetwork(data){
      this.typeChangeSocialNetwork = "update";
      this.mData.dataDefault.listSocialMediaNetwork = DataService.listSocialMediaNetwork.filter(e => e.value == data.type);
      this.mData.dataFormSocialNetWork.type = data.type;
      this.mData.dataFormSocialNetWork.url = data.url;
      this.visibleDialogSocialNetwork = true;
    },
    removeSocialNetwork(index){
      this.mData.dataForm.social_networks = this.mData.dataForm.social_networks.filter((e,i) => {
        return i != index
      })
      this.checkAndRemoveTypeSocialNetWork();
    }
  },
  created() {
    this.applyFullNameValidation();
    this.fn_innitDataDefault();
    if (this.$router.currentRoute.name == "Admin-0-detail") {
      this.mData.viewMode = "employeeInfo";
    }
    if (this.$router.currentRoute.params.id) {
      this.mData.employeeId = this.$router.currentRoute.params.id;
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
    EventBus.$off("click_HSCN_approve");
    EventBus.$off("sendRequestApprove");
    EventBus.$on("sendRequestApprove", async () => {
      await this.sendInformationDataRequest();
    });

    EventBus.$on("click_HSCN_approve", (data) => {
      this.approveDraff(data.type_button);
    });
  },
};
</script>

<style lang="scss" scoped>
.signature-section {
  background: #faf7f2;
  border-radius: 8px;
  padding: 24px 20px;
}
.signature-section__row {
  align-items: stretch;
}
.signature-section__upload-col {
  border-right: 1px solid #e8e0d6;
  padding-right: 24px;
}
.signature-section__upload-col--full {
  border-right: none;
  padding-right: 15px;
}
.signature-section--empty {
  max-width: 420px;
}
.signature-section__right-col {
  padding-left: 24px;
}
.signature-section__label {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #303133;
  text-transform: uppercase;
  margin-bottom: 12px;
}
.signature-section__hint {
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 12px;
  color: #909399;
}
.signature-section__preview-col {
  padding-right: 10px;
}
.signature-section__notes-col {
  padding-left: 10px;
}
.signature-section__right-row {
  height: 100%;
  align-items: stretch;
}
.signature-section__preview-col,
.signature-section__notes-col {
  display: flex;
  flex-direction: column;
}
.signature-preview-box {
  position: relative;
  width: 100%;
  height: 180px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.signature-preview-delete {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 9;
  padding: 6px 8px;
}
::v-deep .signature-preview-image {
  width: 100%;
  height: 100%;
}
::v-deep .signature-preview-image img {
  object-fit: contain !important;
}
.signature-view-btn {
  margin-top: 12px;
  width: 100%;
  background: #fff5eb !important;
  border: 1px solid #ffd9b3 !important;
  color: var(--orange) !important;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
}
.signature-view-btn:hover:not(:disabled),
.signature-view-btn:focus:not(:disabled) {
  background: #ffe8cc !important;
  border-color: var(--orange) !important;
  color: var(--orange) !important;
}
.signature-view-btn.is-disabled {
  opacity: 0.55;
}
.signature-notes-card {
  position: relative;
  flex: 1;
  background: #fff;
  border: 1px solid #f0e6da;
  border-radius: 10px;
  padding: 16px 18px;
  overflow: hidden;
  min-height: 220px;
  height: 100%;
}
.signature-notes-card::after {
  content: "";
  position: absolute;
  right: -10px;
  bottom: -10px;
  width: 90px;
  height: 90px;
  background: radial-gradient(circle at center, rgba(245, 166, 35, 0.18) 0%, rgba(245, 166, 35, 0) 70%);
  pointer-events: none;
}
.signature-notes-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--orange);
  font-weight: 700;
  font-size: 15px;
  margin-bottom: 12px;
}
.signature-notes-card__header i {
  font-size: 18px;
}
.signature-notes-card__list {
  margin: 0;
  padding-left: 18px;
  color: #606266;
  font-size: 13px;
  line-height: 1.7;
}
.signature-notes-card__list li {
  margin-bottom: 4px;
}
.signature-notes-card__list li::marker {
  color: var(--orange);
}
::v-deep .signature-upload {
  width: 100%;
}
::v-deep .signature-upload .el-upload {
  width: 100%;
}
::v-deep .signature-upload .el-upload-dragger {
  width: 100% !important;
  height: 220px !important;
  border: 2px dashed var(--orange) !important;
  border-radius: 8px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
::v-deep .signature-upload .el-upload-dragger:hover {
  border-color: var(--orange) !important;
}
.signature-upload-icon {
  font-size: 48px !important;
  color: var(--orange);
  margin-bottom: 12px;
}
.signature-upload-text {
  color: #606266;
  font-size: 14px;
}
.signature-upload-text em {
  color: var(--orange);
  font-style: normal;
  font-weight: 600;
}
@media (max-width: 991px) {
  .signature-section__upload-col {
    border-right: none;
    border-bottom: 1px solid #e8e0d6;
    padding-right: 15px;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
  .signature-section__right-col {
    padding-left: 15px;
  }
  .signature-section__preview-col {
    margin-bottom: 16px;
  }
}
::v-deep .employee-file .el-upload-dragger {
  height: 36px;
}
::v-deep .approveInfomation {
  .have-change {
    margin-bottom: 10px;
    .el-input__inner {
      background-color: var(--orange_background);
    }
    .el-textarea__inner {
      background-color: var(--orange_background);
    }
  }
}
.object-have-change {
  background-color: var(--orange_background_change);
}
.social-div {
  display: flex;
  margin-bottom: 10px;
  .social-media {
    margin-left: 10px;
    padding-left: 10px;
    padding-right: 10px;
    .social-media__box{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      p{
        font-size: 14px;
        line-height: 19px;
        font-weight: 400;
        display: block;
        width: 350px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover{
          cursor: pointer;
        }
      }
      .social__media-icon {
        width: 32px;
        height: 32px;
        margin-right: 10px;
      }
    }
  }
}
::v-deep .seniority {
  .el-form-item__content {
    display: flex;
    align-items: center;
    height: 32px;
  }
}
::v-deep .time-attendance-photo {
  margin-bottom: 15px;
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
.btn-delete-image {
  position: absolute;
  top: 40%;
  left: 42%;
  z-index: 9;
}
// ::v-deep .have-change .el-input__inner {
//   background-color: var(--orange_background);
// }
.avatar__image:hover{
  cursor: pointer;
}
.isax-save-remove{
  margin-right: 5px;
}
.isax-save-remove::before{
  color: var(--red);
}
.isax-edit::before,
.isax-save-remove::before{
  font-size: 17px;
}
.isax-edit:hover,
.isax-save-remove:hover{
  cursor: pointer;
}
::v-deep .el-icon-close-tip {
  display: none !important;
}
.img__icon-plus{
  width: 39px;
  height: 39px;
  background-color: #fff;
  box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
  border-radius: 50%;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.div-puls__subsidies_salary{
  display: flex;
  position: absolute;
  justify-content: center;
  bottom: -5px;
}
p {
  margin-bottom: 0;
}
::v-deep .el-icon-plus:before{
  font-size: 30px;
  color: var(--orange);
}
.mouse__hover:hover{
  cursor: pointer;
}
.title-card-header {
  font-family: UTM AvoBold !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
  color: var(--orange);
  text-transform: unset;
}
::v-deep .el-collapse {
  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 4px;
  // box-shadow: 0 2px 12px 0 rgba(0 0 0 / 10%);
  box-shadow: 0 2px 12px 0 rgba(143, 140, 140, 0.2);
}
::v-deep .el-collapse-item__header {
  background-color: #fff !important;
  border-radius: 4px;
}
.justify-content {
  justify-content: center;
  align-items: center;
}
.hide {
  ::v-deep.el-upload.el-upload--text {
    display: none;
  }
}

.hide_div {
  display: none;
}
.box-card-information-administrative .aside__information{
  max-width: 270px;
  width: 270px;
  margin-right: 5px;
}
.fd-r{
  flex-direction: column;
}
.aside__information .div-avatar{
  display: flex;
  justify-content: center;
}
.aside__information .div-avatar .el-image{
  width: 190px;
  height: 190px;
  border-radius: 50%;
}
.upload-demo{
  margin-top: 10px !important;
  width: 94px;
  margin: 0 auto;
}
.upload-demo .el-upload .el-button{
  padding: 5px 23px;
  border-radius: 5px !important;
}
.box-card-information-administrative .main__information{
  width: calc(100% - 275px);
}
.box-card-information-timekeeping{
  .el-card__body{

  }
}
.btn-add-new {
  padding: 13px 60px;
  font-size: 14px;
}
::v-deep .avatar_employee .el-form-item .el-form-item__content {
  margin-left: 0 !important;
}
::v-deep label {
  margin-bottom: 0;
}
.btn-add-row {
  font-size: 2rem;
  border: none;
}
::v-deep .el-upload-list__item {
  transition: none !important;
}
.p-relative {
  position: relative;
}
.job-info-group {
  padding: 0;
}
.job-info-item {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.remove-icon {
  position: absolute;
  top: 2px;
  right: 1px;
  max-width: 25px;
  height: 25px;
  border-radius: 10px;
}
.c-ponit:hover {
  cursor: pointer;
}
::v-deep .el-upload-list {
  // max-height: 300px;
  // overflow-y: auto;
  // padding-right: 3px;
  // li {
  //   margin-bottom: 10px;
  // }
  display: flex;
  align-items: center;
  align-content: center;
}
::v-deep .el-collapse-item__wrap{
  min-height: unset;
}
::v-deep .el-upload-list__item:first-child {
  margin-top: 0;
}
::v-deep .el-upload-list__item {
  margin-top: 0;
}
::v-deep .col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col,
.col-auto,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm,.col-sm-auto,
.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md,.col-md-auto,
.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg,.col-lg-auto,
.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl,.col-xl-auto {
  padding-left: 10px;
  padding-right: 10px;
}

.dialog-image {
  max-height: calc(100vh - 158px);
}

.fas_icon {
  // top: -15px;
  z-index: 9;
  position: absolute;
  left: 160px;
}
.fas_icon:hover {
  cursor: pointer;
}
.demo-upload__image {
  width: 144px;
  height: 144px;
  border-radius: 7px;
  top: 2px;
  left: 2px;
  opacity: 0.5;
}
.upload-image {
  position: absolute;
  z-index: 9;
  top: 0;
}
::v-deep .el-upload--picture-card {
  background-color: transparent;
}
::v-deep .account .el-form-item__error {
  line-height: 1.39;
}
::v-deep .dialog-history .el-dialog .el-dialog__body {
  max-height: calc(100vh - 120px);
  overflow: auto;
}
::v-deep .el-collapse-item__arrow{
  font-size: 20px;
  font-weight: 900;
  color: var(--orange);
}
::v-deep .el-switch__core{
  height: 30px;
  width: 60px !important;
  border-radius: 45px;
}
::v-deep .el-switch__core:after{
  border-radius: 50%;
  height: 30px;
  width: 30px;
  top: -1px;
  left: -1px;
}
::v-deep .el-switch.is-checked .el-switch__core::after{
  margin-left: -30px;
}
.social-media{
  padding-left: 10px;
  padding-right: 10px;
}
.social-media__box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.social-media__box p:hover{
  cursor: pointer;
}
.social-media__box p{
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;
  display: block;
  width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.social__media-icon {
  width: 32px;
  height: 32px;
  margin-right: 10px;
}
::v-deep .social__media-box .el-form-item__content {
  margin-left: 0px !important;
}
.add-new-social__network {
  flex-shrink: 0;
  &:hover {
    cursor: pointer;
  }
  .add-new-social__network-text{
    color: var(--link-color);
  }
}
::v-deep .dialog__social-netwotk .el-dialog__header {
  padding: 8px 10px 8px 8px;
}
::v-deep .dialog__social-netwotk .el-dialog__title {
  text-transform: uppercase;
}
@media (max-width: 1600px) {
  .box-card-information-administrative .aside__information{
    max-width: 230px;
    width: 200px;
  }
  .aside__information .div-avatar .el-image{
    width: 170px;
    height: 170px;
  }
  .box-card-information-administrative .main__information{
    width: calc(100% - 200px);
  }
}
@media (max-width: 1470px) and (min-width: 991px) {
  ::v-deep .el-form-item__content{
    margin-left: 0 !important;
  }
}
@media (max-width: 900px) {
  .w__900{
    flex-direction: column;
  }
  .box-card-information-administrative .aside__information{
    width: 100%;
    max-width: 100%;
  }
  .box-card-information-administrative .main__information{
    width: 100%;
  }
}
@media (max-width: 576px) {
  .subsidize .el-form-item .el-form-item__content .icon-remove {
    text-align: center;
  }
}
@media (max-width: 1080px){
  .col-md-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
